// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { getAuthoringSchemaStudiesAuthoringSchemaSchemaNameGet, getChtColorsAuthPreferencesChtColormapGet, handleAddManualDesignPointsStudiesStudyIdDesignPointsManualPost, handleAddStudyInputStudiesStudyIdInputsPost, handleApproveSimplifyGeometriesGeometryIdApprovePost, handleAssignProductSeatOrganizationMembersMemberIdSeatsProductPut, handleAssignSeatOrganizationMembersMemberIdSeatPut, handleAuthConfigAuthConfigGet, handleAuthCurrentAuthCurrentGet, handleAuthorizationEndpointOauthAuthorizeGet, handleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGet, handleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPost, handleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePost, handleCancelMeshMeshesMeshIdCancelPost, handleCancelSimulationSimulationsSimulationIdCancelPost, handleCancelStudyStudiesStudyIdCancelPost, handleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatch, handleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatch, handleChangeSubscriptionBillingSubscriptionPost, handleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPost, handleCheckGeometryPartsGeometriesGeometryIdPartCheckPost, handleCloneDesignPointsStudiesStudyIdPointsClonePost, handleCompleteMeshingStudiesStudyIdCompleteMeshingPost, handleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPost, handleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPost, handleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPost, handleConfirmUploadGeometriesGeometryIdConfirmUploadPost, handleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPost, handleContinueDesignPointStudiesStudyIdPointsDpIdContinuePost, handleCreateBillingPortalSessionBillingPortalPost, handleCreateCheckoutSessionBillingCheckoutPost, handleCreateCommentStudiesStudyIdCommentsPost, handleCreateInviteGeometriesGeometryIdSharingInvitesPost, handleCreateInviteStudiesStudyIdSharingInvitesPost, handleCreateMeshGeometriesGeometryIdMeshPost, handleCreateStudyStudiesPost, handleDecideStudyStudiesStudyIdDecidePost, handleDeleteCommentCommentsCommentIdDelete, handleDeleteGeometryGeometriesGeometryIdDelete, handleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDelete, handleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDelete, handleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDelete, handleDeleteStudyStudiesStudyIdDelete, handleDiagnoseGeometriesGeometryIdDiagnosePost, handleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPost, handleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGet, handleDownloadGeometryGeometriesGeometryIdDownloadGet, handleDownloadMeshMeshesMeshIdDownloadGet, handleDownloadSimulationInputSimulationsSimulationIdDownloadInputGet, handleDownloadSimulationSimulationsSimulationIdDownloadGet, handleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPost, handleFluidProbeGeometriesGeometryIdRegionPrepProbePost, handleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePost, handleGeometryEditAccessGeometriesGeometryIdEditAccessPost, handleGeometryEditCancelGeometryEditsEditIdCancelPost, handleGeometryEditFinalizeGeometryEditsEditIdFinalizePost, handleGeometryEditReceiptGeometryEditsEditIdPublicationGet, handleGeometryEditReleaseGeometryEditsEditIdReleasePost, handleGeometryEditUploadGeometryEditsEditIdUploadAccessPost, handleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGet, handleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPost, handleGetBondedProposalsGeometriesGeometryIdBondedProposalsGet, handleGetCurrentOrganizationOrganizationGet, handleGetDesignPointStudiesStudyIdPointsDpIdGet, handleGetEnclosureGeometriesGeometryIdEnclosureGet, handleGetFaceLabelsGeometriesGeometryIdFaceLabelsGet, handleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGet, handleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGet, handleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGet, handleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGet, handleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGet, handleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGet, handleGetGeometryGeometriesGeometryIdGet, handleGetGeometryHandoffGeometriesGeometryIdHandoffGet, handleGetGeometryViewGeometriesGeometryIdViewsLodGet, handleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGet, handleGetLineageGeometriesGeometryIdLineageGet, handleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGet, handleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGet, handleGetMeshFaceTagsMeshesMeshIdFaceTagsGet, handleGetMeshLogsMeshesMeshIdLogsGet, handleGetMeshMeshesMeshIdGet, handleGetMeshPatchesMeshesMeshIdPatchesGet, handleGetMeshRetryChainMeshesMeshIdRetryChainGet, handleGetRegionPrepGeometriesGeometryIdRegionPrepGet, handleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGet, handleGetSharingGeometriesGeometryIdSharingGet, handleGetSharingStudiesStudyIdSharingGet, handleGetSimulationConvergenceSimulationsSimulationIdConvergenceGet, handleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGet, handleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGet, handleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGet, handleGetSimulationLogsSimulationsSimulationIdLogsGet, handleGetSimulationMonitoringSimulationsSimulationIdMonitoringGet, handleGetSimulationResidualsSimulationsSimulationIdResidualsGet, handleGetSimulationSeriesSimulationsSimulationIdSeriesGet, handleGetSimulationSimulationsSimulationIdGet, handleGetSimulationThumbnailSimulationsSimulationIdThumbnailGet, handleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGet, handleGetStudyDesignIntentStudiesStudyIdDesignIntentGet, handleGetStudyReportStudiesStudyIdReportGet, handleGetStudyStudiesStudyIdGet, handleGetSubscriptionSubscriptionGet, handleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGet, handleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGet, handleGetSurfacesGeometriesGeometryIdSurfacesGet, handleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGet, handleGetSurfacesStlGeometriesGeometryIdSurfacesStlGet, handleGetUsageUsageGet, handleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGet, handleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGet, handleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatch, handleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGet, handleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePost, handleHealthHealthGet, handleImportPropertyCurveMaterialsCurveImportPost, handleInviteOrganizationMemberOrganizationMembersInvitePost, handleListCommentsStudiesStudyIdCommentsGet, handleListFluidMaterialsMaterialsFluidsGet, handleListGeometriesGeometriesGet, handleListGeometryMeshesGeometriesGeometryIdMeshesGet, handleListMeshesMeshesGet, handleListOrganizationMembersOrganizationMembersGet, handleListPointsStudiesStudyIdPointsGet, handleListReportEditsStudiesStudyIdReportEditsGet, handleListSimulationsSimulationsGet, handleListSolidMaterialsMaterialsSolidsGet, handleListSolverConstantsSolversCalculixConstantsGet, handleListStructuralMaterialsMaterialsStructuralGet, handleListStudiesStudiesGet, handleMcpDeleteMcpDelete, handleMcpGetMcpGet, handleMcpPostMcpPost, handleMeshUploadUrlMeshesUploadUrlPost, handleMutateDesignPointStudiesStudyIdPointsDpIdMutatePost, handleNotifyGeometryGeometriesGeometryIdNotifyPost, handleNotifyMeshMeshesMeshIdNotifyPost, handleNotifyStudyStudiesStudyIdNotifyPost, handlePreviewStudyReportStudiesStudyIdReportPreviewPost, handlePreviewSubscriptionChangeBillingSubscriptionPreviewPost, handleProtectedResourceMetadataWellKnownOauthProtectedResourceGet, handlePutDesignIntentGeometriesGeometryIdDesignIntentPut, handlePutFaceLabelsGeometriesGeometryIdFaceLabelsPut, handlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPut, handleRecordAgentUsageInternalUsageAgentPost, handleRefineMeshMeshesMeshIdRefinePost, handleRegionPrepGeometriesGeometryIdRegionPrepPost, handleRejectSimplifyGeometriesGeometryIdRejectPost, handleRemoveOrganizationMemberOrganizationMembersMemberIdDelete, handleRenameGeometryGeometriesGeometryIdNamePatch, handleRenameOrganizationOrganizationPatch, handleRepairGeometriesGeometryIdRepairPost, handleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPost, handleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPost, handleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPost, handleRetryMeshAiMeshesMeshIdRetryAiPost, handleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDelete, handleRunStudyStudiesStudyIdRunPost, handleSetCaseCardStudiesStudyIdCaseCardPut, handleSimplifyGeometriesGeometryIdSimplifyPost, handleStripeWebhookRouteWebhooksStripePost, handleSubmitDesignPointStudiesStudyIdPointsPost, handleTeardownOrganizationOrganizationDelete, handleTransferOrganizationOwnershipOrganizationOwnershipTransferPost, handleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDelete, handleUnassignSeatOrganizationMembersMemberIdSeatDelete, handleUpdateAutoRetryStudiesStudyIdAutoRetryPatch, handleUpdateCommentCommentsCommentIdPatch, handleUpdateDesignPointStudiesStudyIdPointsDpIdPatch, handleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatch, handleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatch, handleUpdateOrganizationDomainsOrganizationDomainsPut, handleUpdateSharingGeometriesGeometryIdSharingPut, handleUpdateSharingStudiesStudyIdSharingPut, handleUpdateStudyStudiesStudyIdPatch, handleUpdateVisibilityGeometriesGeometryIdVisibilityPatch, handleUpdateVisibilityStudiesStudyIdVisibilityPatch, handleUploadRevisionGeometriesGeometryIdUploadRevisionPost, handleUploadUrlGeometriesUploadUrlPost, handleWriteStudyReportStudiesStudyIdReportWritePost, type Options, putChtColorsAuthPreferencesChtColormapPut } from '../sdk.gen';
import type { GetAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetData, GetAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetError, GetAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetResponse, GetChtColorsAuthPreferencesChtColormapGetData, GetChtColorsAuthPreferencesChtColormapGetError, GetChtColorsAuthPreferencesChtColormapGetResponse, HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostData, HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostError, HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostResponse, HandleAddStudyInputStudiesStudyIdInputsPostData, HandleAddStudyInputStudiesStudyIdInputsPostError, HandleAddStudyInputStudiesStudyIdInputsPostResponse, HandleApproveSimplifyGeometriesGeometryIdApprovePostData, HandleApproveSimplifyGeometriesGeometryIdApprovePostError, HandleApproveSimplifyGeometriesGeometryIdApprovePostResponse, HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutData, HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutError, HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutResponse, HandleAssignSeatOrganizationMembersMemberIdSeatPutData, HandleAssignSeatOrganizationMembersMemberIdSeatPutError, HandleAssignSeatOrganizationMembersMemberIdSeatPutResponse, HandleAuthConfigAuthConfigGetData, HandleAuthConfigAuthConfigGetError, HandleAuthConfigAuthConfigGetResponse, HandleAuthCurrentAuthCurrentGetData, HandleAuthCurrentAuthCurrentGetError, HandleAuthCurrentAuthCurrentGetResponse, HandleAuthorizationEndpointOauthAuthorizeGetData, HandleAuthorizationEndpointOauthAuthorizeGetError, HandleAuthorizationEndpointOauthAuthorizeGetResponse, HandleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetData, HandleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetError, HandleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetResponse, HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostData, HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostError, HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostResponse, HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostData, HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostError, HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostResponse, HandleCancelMeshMeshesMeshIdCancelPostData, HandleCancelMeshMeshesMeshIdCancelPostError, HandleCancelMeshMeshesMeshIdCancelPostResponse, HandleCancelSimulationSimulationsSimulationIdCancelPostData, HandleCancelSimulationSimulationsSimulationIdCancelPostError, HandleCancelSimulationSimulationsSimulationIdCancelPostResponse, HandleCancelStudyStudiesStudyIdCancelPostData, HandleCancelStudyStudiesStudyIdCancelPostError, HandleCancelStudyStudiesStudyIdCancelPostResponse, HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchData, HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchError, HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchResponse, HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchData, HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchError, HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchResponse, HandleChangeSubscriptionBillingSubscriptionPostData, HandleChangeSubscriptionBillingSubscriptionPostError, HandleChangeSubscriptionBillingSubscriptionPostResponse, HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostData, HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostError, HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostResponse, HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostData, HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostError, HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostResponse, HandleCloneDesignPointsStudiesStudyIdPointsClonePostData, HandleCloneDesignPointsStudiesStudyIdPointsClonePostError, HandleCloneDesignPointsStudiesStudyIdPointsClonePostResponse, HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostData, HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostError, HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostResponse, HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostData, HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostError, HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostResponse, HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostData, HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostError, HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostResponse, HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostData, HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostError, HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostResponse, HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostData, HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostError, HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostResponse, HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostData, HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostError, HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostResponse, HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostData, HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostError, HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostResponse, HandleCreateBillingPortalSessionBillingPortalPostData, HandleCreateBillingPortalSessionBillingPortalPostError, HandleCreateBillingPortalSessionBillingPortalPostResponse, HandleCreateCheckoutSessionBillingCheckoutPostData, HandleCreateCheckoutSessionBillingCheckoutPostError, HandleCreateCheckoutSessionBillingCheckoutPostResponse, HandleCreateCommentStudiesStudyIdCommentsPostData, HandleCreateCommentStudiesStudyIdCommentsPostError, HandleCreateCommentStudiesStudyIdCommentsPostResponse, HandleCreateInviteGeometriesGeometryIdSharingInvitesPostData, HandleCreateInviteGeometriesGeometryIdSharingInvitesPostError, HandleCreateInviteGeometriesGeometryIdSharingInvitesPostResponse, HandleCreateInviteStudiesStudyIdSharingInvitesPostData, HandleCreateInviteStudiesStudyIdSharingInvitesPostError, HandleCreateInviteStudiesStudyIdSharingInvitesPostResponse, HandleCreateMeshGeometriesGeometryIdMeshPostData, HandleCreateMeshGeometriesGeometryIdMeshPostError, HandleCreateMeshGeometriesGeometryIdMeshPostResponse, HandleCreateStudyStudiesPostData, HandleCreateStudyStudiesPostError, HandleCreateStudyStudiesPostResponse, HandleDecideStudyStudiesStudyIdDecidePostData, HandleDecideStudyStudiesStudyIdDecidePostError, HandleDecideStudyStudiesStudyIdDecidePostResponse, HandleDeleteCommentCommentsCommentIdDeleteData, HandleDeleteCommentCommentsCommentIdDeleteError, HandleDeleteCommentCommentsCommentIdDeleteResponse, HandleDeleteGeometryGeometriesGeometryIdDeleteData, HandleDeleteGeometryGeometriesGeometryIdDeleteError, HandleDeleteGeometryGeometriesGeometryIdDeleteResponse, HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteData, HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteError, HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteResponse, HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteData, HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteError, HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteResponse, HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteData, HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteError, HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteResponse, HandleDeleteStudyStudiesStudyIdDeleteData, HandleDeleteStudyStudiesStudyIdDeleteError, HandleDeleteStudyStudiesStudyIdDeleteResponse, HandleDiagnoseGeometriesGeometryIdDiagnosePostData, HandleDiagnoseGeometriesGeometryIdDiagnosePostError, HandleDiagnoseGeometriesGeometryIdDiagnosePostResponse, HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostData, HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostError, HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostResponse, HandleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetData, HandleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetError, HandleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetResponse, HandleDownloadGeometryGeometriesGeometryIdDownloadGetData, HandleDownloadGeometryGeometriesGeometryIdDownloadGetError, HandleDownloadGeometryGeometriesGeometryIdDownloadGetResponse, HandleDownloadMeshMeshesMeshIdDownloadGetData, HandleDownloadMeshMeshesMeshIdDownloadGetError, HandleDownloadMeshMeshesMeshIdDownloadGetResponse, HandleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetData, HandleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetError, HandleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetResponse, HandleDownloadSimulationSimulationsSimulationIdDownloadGetData, HandleDownloadSimulationSimulationsSimulationIdDownloadGetError, HandleDownloadSimulationSimulationsSimulationIdDownloadGetResponse, HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostData, HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostError, HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostResponse, HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostData, HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostError, HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostResponse, HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostData, HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostError, HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostResponse, HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostData, HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostError, HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostResponse, HandleGeometryEditCancelGeometryEditsEditIdCancelPostData, HandleGeometryEditCancelGeometryEditsEditIdCancelPostError, HandleGeometryEditCancelGeometryEditsEditIdCancelPostResponse, HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostData, HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostError, HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostResponse, HandleGeometryEditReceiptGeometryEditsEditIdPublicationGetData, HandleGeometryEditReceiptGeometryEditsEditIdPublicationGetError, HandleGeometryEditReceiptGeometryEditsEditIdPublicationGetResponse, HandleGeometryEditReleaseGeometryEditsEditIdReleasePostData, HandleGeometryEditReleaseGeometryEditsEditIdReleasePostError, HandleGeometryEditReleaseGeometryEditsEditIdReleasePostResponse, HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostData, HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostError, HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostResponse, HandleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetData, HandleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetError, HandleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetResponse, HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostData, HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostError, HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostResponse, HandleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetData, HandleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetError, HandleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetResponse, HandleGetCurrentOrganizationOrganizationGetData, HandleGetCurrentOrganizationOrganizationGetError, HandleGetCurrentOrganizationOrganizationGetResponse, HandleGetDesignPointStudiesStudyIdPointsDpIdGetData, HandleGetDesignPointStudiesStudyIdPointsDpIdGetError, HandleGetDesignPointStudiesStudyIdPointsDpIdGetResponse, HandleGetEnclosureGeometriesGeometryIdEnclosureGetData, HandleGetEnclosureGeometriesGeometryIdEnclosureGetError, HandleGetEnclosureGeometriesGeometryIdEnclosureGetResponse, HandleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetData, HandleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetError, HandleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetResponse, HandleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetData, HandleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetError, HandleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetResponse, HandleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetData, HandleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetError, HandleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetResponse, HandleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetData, HandleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetError, HandleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetResponse, HandleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetData, HandleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetError, HandleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetResponse, HandleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetData, HandleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetError, HandleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetResponse, HandleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetData, HandleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetError, HandleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetResponse, HandleGetGeometryGeometriesGeometryIdGetData, HandleGetGeometryGeometriesGeometryIdGetError, HandleGetGeometryGeometriesGeometryIdGetResponse, HandleGetGeometryHandoffGeometriesGeometryIdHandoffGetData, HandleGetGeometryHandoffGeometriesGeometryIdHandoffGetError, HandleGetGeometryHandoffGeometriesGeometryIdHandoffGetResponse, HandleGetGeometryViewGeometriesGeometryIdViewsLodGetData, HandleGetGeometryViewGeometriesGeometryIdViewsLodGetError, HandleGetGeometryViewGeometriesGeometryIdViewsLodGetResponse, HandleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetData, HandleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetError, HandleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetResponse, HandleGetLineageGeometriesGeometryIdLineageGetData, HandleGetLineageGeometriesGeometryIdLineageGetError, HandleGetLineageGeometriesGeometryIdLineageGetResponse, HandleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetData, HandleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetError, HandleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetResponse, HandleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetData, HandleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetError, HandleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetResponse, HandleGetMeshFaceTagsMeshesMeshIdFaceTagsGetData, HandleGetMeshFaceTagsMeshesMeshIdFaceTagsGetError, HandleGetMeshFaceTagsMeshesMeshIdFaceTagsGetResponse, HandleGetMeshLogsMeshesMeshIdLogsGetData, HandleGetMeshLogsMeshesMeshIdLogsGetError, HandleGetMeshLogsMeshesMeshIdLogsGetResponse, HandleGetMeshMeshesMeshIdGetData, HandleGetMeshMeshesMeshIdGetError, HandleGetMeshMeshesMeshIdGetResponse, HandleGetMeshPatchesMeshesMeshIdPatchesGetData, HandleGetMeshPatchesMeshesMeshIdPatchesGetError, HandleGetMeshPatchesMeshesMeshIdPatchesGetResponse, HandleGetMeshRetryChainMeshesMeshIdRetryChainGetData, HandleGetMeshRetryChainMeshesMeshIdRetryChainGetError, HandleGetMeshRetryChainMeshesMeshIdRetryChainGetResponse, HandleGetRegionPrepGeometriesGeometryIdRegionPrepGetData, HandleGetRegionPrepGeometriesGeometryIdRegionPrepGetError, HandleGetRegionPrepGeometriesGeometryIdRegionPrepGetResponse, HandleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetData, HandleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetError, HandleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetResponse, HandleGetSharingGeometriesGeometryIdSharingGetData, HandleGetSharingGeometriesGeometryIdSharingGetError, HandleGetSharingGeometriesGeometryIdSharingGetResponse, HandleGetSharingStudiesStudyIdSharingGetData, HandleGetSharingStudiesStudyIdSharingGetError, HandleGetSharingStudiesStudyIdSharingGetResponse, HandleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetData, HandleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetError, HandleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetResponse, HandleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetData, HandleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetError, HandleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetResponse, HandleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetData, HandleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetError, HandleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetResponse, HandleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetData, HandleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetError, HandleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetResponse, HandleGetSimulationLogsSimulationsSimulationIdLogsGetData, HandleGetSimulationLogsSimulationsSimulationIdLogsGetError, HandleGetSimulationLogsSimulationsSimulationIdLogsGetResponse, HandleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetData, HandleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetError, HandleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetResponse, HandleGetSimulationResidualsSimulationsSimulationIdResidualsGetData, HandleGetSimulationResidualsSimulationsSimulationIdResidualsGetError, HandleGetSimulationResidualsSimulationsSimulationIdResidualsGetResponse, HandleGetSimulationSeriesSimulationsSimulationIdSeriesGetData, HandleGetSimulationSeriesSimulationsSimulationIdSeriesGetError, HandleGetSimulationSeriesSimulationsSimulationIdSeriesGetResponse, HandleGetSimulationSimulationsSimulationIdGetData, HandleGetSimulationSimulationsSimulationIdGetError, HandleGetSimulationSimulationsSimulationIdGetResponse, HandleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetData, HandleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetError, HandleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetResponse, HandleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetData, HandleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetError, HandleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetResponse, HandleGetStudyDesignIntentStudiesStudyIdDesignIntentGetData, HandleGetStudyDesignIntentStudiesStudyIdDesignIntentGetError, HandleGetStudyDesignIntentStudiesStudyIdDesignIntentGetResponse, HandleGetStudyReportStudiesStudyIdReportGetData, HandleGetStudyReportStudiesStudyIdReportGetError, HandleGetStudyReportStudiesStudyIdReportGetResponse, HandleGetStudyStudiesStudyIdGetData, HandleGetStudyStudiesStudyIdGetError, HandleGetStudyStudiesStudyIdGetResponse, HandleGetSubscriptionSubscriptionGetData, HandleGetSubscriptionSubscriptionGetError, HandleGetSubscriptionSubscriptionGetResponse, HandleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetData, HandleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetError, HandleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetResponse, HandleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetData, HandleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetError, HandleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetResponse, HandleGetSurfacesGeometriesGeometryIdSurfacesGetData, HandleGetSurfacesGeometriesGeometryIdSurfacesGetError, HandleGetSurfacesGeometriesGeometryIdSurfacesGetResponse, HandleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetData, HandleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetError, HandleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetResponse, HandleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetData, HandleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetError, HandleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetResponse, HandleGetUsageUsageGetData, HandleGetUsageUsageGetError, HandleGetUsageUsageGetResponse, HandleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetData, HandleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetError, HandleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetResponse, HandleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetData, HandleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetError, HandleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetResponse, HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchData, HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchError, HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchResponse, HandleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetData, HandleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetError, HandleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetResponse, HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostData, HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostError, HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostResponse, HandleHealthHealthGetData, HandleHealthHealthGetError, HandleHealthHealthGetResponse, HandleImportPropertyCurveMaterialsCurveImportPostData, HandleImportPropertyCurveMaterialsCurveImportPostError, HandleImportPropertyCurveMaterialsCurveImportPostResponse, HandleInviteOrganizationMemberOrganizationMembersInvitePostData, HandleInviteOrganizationMemberOrganizationMembersInvitePostError, HandleInviteOrganizationMemberOrganizationMembersInvitePostResponse, HandleListCommentsStudiesStudyIdCommentsGetData, HandleListCommentsStudiesStudyIdCommentsGetError, HandleListCommentsStudiesStudyIdCommentsGetResponse, HandleListFluidMaterialsMaterialsFluidsGetData, HandleListFluidMaterialsMaterialsFluidsGetError, HandleListFluidMaterialsMaterialsFluidsGetResponse, HandleListGeometriesGeometriesGetData, HandleListGeometriesGeometriesGetError, HandleListGeometriesGeometriesGetResponse, HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData, HandleListGeometryMeshesGeometriesGeometryIdMeshesGetError, HandleListGeometryMeshesGeometriesGeometryIdMeshesGetResponse, HandleListMeshesMeshesGetData, HandleListMeshesMeshesGetError, HandleListMeshesMeshesGetResponse, HandleListOrganizationMembersOrganizationMembersGetData, HandleListOrganizationMembersOrganizationMembersGetError, HandleListOrganizationMembersOrganizationMembersGetResponse, HandleListPointsStudiesStudyIdPointsGetData, HandleListPointsStudiesStudyIdPointsGetError, HandleListPointsStudiesStudyIdPointsGetResponse, HandleListReportEditsStudiesStudyIdReportEditsGetData, HandleListReportEditsStudiesStudyIdReportEditsGetError, HandleListReportEditsStudiesStudyIdReportEditsGetResponse, HandleListSimulationsSimulationsGetData, HandleListSimulationsSimulationsGetError, HandleListSimulationsSimulationsGetResponse, HandleListSolidMaterialsMaterialsSolidsGetData, HandleListSolidMaterialsMaterialsSolidsGetError, HandleListSolidMaterialsMaterialsSolidsGetResponse, HandleListSolverConstantsSolversCalculixConstantsGetData, HandleListSolverConstantsSolversCalculixConstantsGetError, HandleListSolverConstantsSolversCalculixConstantsGetResponse, HandleListStructuralMaterialsMaterialsStructuralGetData, HandleListStructuralMaterialsMaterialsStructuralGetError, HandleListStructuralMaterialsMaterialsStructuralGetResponse, HandleListStudiesStudiesGetData, HandleListStudiesStudiesGetError, HandleListStudiesStudiesGetResponse, HandleMcpDeleteMcpDeleteData, HandleMcpDeleteMcpDeleteError, HandleMcpDeleteMcpDeleteResponse, HandleMcpGetMcpGetData, HandleMcpGetMcpGetError, HandleMcpGetMcpGetResponse, HandleMcpPostMcpPostData, HandleMcpPostMcpPostError, HandleMcpPostMcpPostResponse, HandleMeshUploadUrlMeshesUploadUrlPostData, HandleMeshUploadUrlMeshesUploadUrlPostError, HandleMeshUploadUrlMeshesUploadUrlPostResponse, HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostData, HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostError, HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostResponse, HandleNotifyGeometryGeometriesGeometryIdNotifyPostData, HandleNotifyGeometryGeometriesGeometryIdNotifyPostError, HandleNotifyGeometryGeometriesGeometryIdNotifyPostResponse, HandleNotifyMeshMeshesMeshIdNotifyPostData, HandleNotifyMeshMeshesMeshIdNotifyPostError, HandleNotifyMeshMeshesMeshIdNotifyPostResponse, HandleNotifyStudyStudiesStudyIdNotifyPostData, HandleNotifyStudyStudiesStudyIdNotifyPostError, HandleNotifyStudyStudiesStudyIdNotifyPostResponse, HandlePreviewStudyReportStudiesStudyIdReportPreviewPostData, HandlePreviewStudyReportStudiesStudyIdReportPreviewPostError, HandlePreviewStudyReportStudiesStudyIdReportPreviewPostResponse, HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostData, HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostError, HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostResponse, HandleProtectedResourceMetadataWellKnownOauthProtectedResourceGetData, HandleProtectedResourceMetadataWellKnownOauthProtectedResourceGetError, HandleProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponse, HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutData, HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutError, HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutResponse, HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutData, HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutError, HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutResponse, HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutData, HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutError, HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutResponse, HandleRecordAgentUsageInternalUsageAgentPostData, HandleRecordAgentUsageInternalUsageAgentPostError, HandleRecordAgentUsageInternalUsageAgentPostResponse, HandleRefineMeshMeshesMeshIdRefinePostData, HandleRefineMeshMeshesMeshIdRefinePostError, HandleRefineMeshMeshesMeshIdRefinePostResponse, HandleRegionPrepGeometriesGeometryIdRegionPrepPostData, HandleRegionPrepGeometriesGeometryIdRegionPrepPostError, HandleRegionPrepGeometriesGeometryIdRegionPrepPostResponse, HandleRejectSimplifyGeometriesGeometryIdRejectPostData, HandleRejectSimplifyGeometriesGeometryIdRejectPostError, HandleRejectSimplifyGeometriesGeometryIdRejectPostResponse, HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteData, HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteError, HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteResponse, HandleRenameGeometryGeometriesGeometryIdNamePatchData, HandleRenameGeometryGeometriesGeometryIdNamePatchError, HandleRenameGeometryGeometriesGeometryIdNamePatchResponse, HandleRenameOrganizationOrganizationPatchData, HandleRenameOrganizationOrganizationPatchError, HandleRenameOrganizationOrganizationPatchResponse, HandleRepairGeometriesGeometryIdRepairPostData, HandleRepairGeometriesGeometryIdRepairPostError, HandleRepairGeometriesGeometryIdRepairPostResponse, HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostData, HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostError, HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostResponse, HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostData, HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostError, HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostResponse, HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostData, HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostError, HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostResponse, HandleRetryMeshAiMeshesMeshIdRetryAiPostData, HandleRetryMeshAiMeshesMeshIdRetryAiPostError, HandleRetryMeshAiMeshesMeshIdRetryAiPostResponse, HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteData, HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteError, HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteResponse, HandleRunStudyStudiesStudyIdRunPostData, HandleRunStudyStudiesStudyIdRunPostError, HandleRunStudyStudiesStudyIdRunPostResponse, HandleSetCaseCardStudiesStudyIdCaseCardPutData, HandleSetCaseCardStudiesStudyIdCaseCardPutError, HandleSetCaseCardStudiesStudyIdCaseCardPutResponse, HandleSimplifyGeometriesGeometryIdSimplifyPostData, HandleSimplifyGeometriesGeometryIdSimplifyPostError, HandleSimplifyGeometriesGeometryIdSimplifyPostResponse, HandleStripeWebhookRouteWebhooksStripePostData, HandleStripeWebhookRouteWebhooksStripePostError, HandleStripeWebhookRouteWebhooksStripePostResponse, HandleSubmitDesignPointStudiesStudyIdPointsPostData, HandleSubmitDesignPointStudiesStudyIdPointsPostError, HandleSubmitDesignPointStudiesStudyIdPointsPostResponse, HandleTeardownOrganizationOrganizationDeleteData, HandleTeardownOrganizationOrganizationDeleteError, HandleTeardownOrganizationOrganizationDeleteResponse, HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostData, HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostError, HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostResponse, HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteData, HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteError, HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteResponse, HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteData, HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteError, HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteResponse, HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchData, HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchError, HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchResponse, HandleUpdateCommentCommentsCommentIdPatchData, HandleUpdateCommentCommentsCommentIdPatchError, HandleUpdateCommentCommentsCommentIdPatchResponse, HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchData, HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchError, HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchResponse, HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchData, HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchError, HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchResponse, HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchData, HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchError, HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchResponse, HandleUpdateOrganizationDomainsOrganizationDomainsPutData, HandleUpdateOrganizationDomainsOrganizationDomainsPutError, HandleUpdateOrganizationDomainsOrganizationDomainsPutResponse, HandleUpdateSharingGeometriesGeometryIdSharingPutData, HandleUpdateSharingGeometriesGeometryIdSharingPutError, HandleUpdateSharingGeometriesGeometryIdSharingPutResponse, HandleUpdateSharingStudiesStudyIdSharingPutData, HandleUpdateSharingStudiesStudyIdSharingPutError, HandleUpdateSharingStudiesStudyIdSharingPutResponse, HandleUpdateStudyStudiesStudyIdPatchData, HandleUpdateStudyStudiesStudyIdPatchError, HandleUpdateStudyStudiesStudyIdPatchResponse, HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchData, HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchError, HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchResponse, HandleUpdateVisibilityStudiesStudyIdVisibilityPatchData, HandleUpdateVisibilityStudiesStudyIdVisibilityPatchError, HandleUpdateVisibilityStudiesStudyIdVisibilityPatchResponse, HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostData, HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostError, HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostResponse, HandleUploadUrlGeometriesUploadUrlPostData, HandleUploadUrlGeometriesUploadUrlPostError, HandleUploadUrlGeometriesUploadUrlPostResponse, HandleWriteStudyReportStudiesStudyIdReportWritePostData, HandleWriteStudyReportStudiesStudyIdReportWritePostError, HandleWriteStudyReportStudiesStudyIdReportWritePostResponse, PutChtColorsAuthPreferencesChtColormapPutData, PutChtColorsAuthPreferencesChtColormapPutError, PutChtColorsAuthPreferencesChtColormapPutResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const handleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetQueryKey = (options: Options<HandleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetData>) => createQueryKey('handleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGet', options);

/**
 * Get fastener proposals
 *
 * Read measured shank/bore candidates with body and face indices. No study is changed. Ask the user to select interfaces, then call confirm_fastener_proposals with this revision. Legacy diagnosis without face identities requires diagnosis again. Does not infer preload or faying contact.
 */
export const handleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetOptions = (options: Options<HandleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetData>) => queryOptions<HandleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetResponse, HandleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetError, HandleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetResponse, ReturnType<typeof handleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetFastenerProposalsGeometriesGeometryIdFastenerProposalsGetQueryKey(options)
});

export const handleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetQueryKey = (options: Options<HandleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetData>) => createQueryKey('handleGetBondedProposalsGeometriesGeometryIdBondedProposalsGet', options);

/**
 * Get bonded proposals
 *
 * Read measured faying-face candidates as review-only bonded interface proposals. No study is changed. Select the intended bonds and dependent side, then confirm against this diagnosis revision. Contact or slip remains a separate choice.
 */
export const handleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetOptions = (options: Options<HandleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetData>) => queryOptions<HandleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetResponse, HandleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetError, HandleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetResponse, ReturnType<typeof handleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetBondedProposalsGeometriesGeometryIdBondedProposalsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetBondedProposalsGeometriesGeometryIdBondedProposalsGetQueryKey(options)
});

/**
 * Upload geometry revision
 *
 * Upload a replacement CAD file as a new version in an existing geometry's lineage; returns the new geometry_id and a presigned upload_url to PUT the file to. Requires editor access. After the PUT, call confirm_geometry_upload on the new geometry_id to finalise (or diagnose_geometry, which confirms when the object is present).
 */
export const handleUploadRevisionGeometriesGeometryIdUploadRevisionPostMutation = (options?: Partial<Options<HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostData>>): UseMutationOptions<HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostResponse, HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostError, Options<HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostData>> => {
    const mutationOptions: UseMutationOptions<HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostResponse, HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostError, Options<HandleUploadRevisionGeometriesGeometryIdUploadRevisionPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUploadRevisionGeometriesGeometryIdUploadRevisionPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete geometry
 *
 * Soft-delete a geometry so it no longer appears in listings (owner only); returns 204 with no body.
 */
export const handleDeleteGeometryGeometriesGeometryIdDeleteMutation = (options?: Partial<Options<HandleDeleteGeometryGeometriesGeometryIdDeleteData>>): UseMutationOptions<HandleDeleteGeometryGeometriesGeometryIdDeleteResponse, HandleDeleteGeometryGeometriesGeometryIdDeleteError, Options<HandleDeleteGeometryGeometriesGeometryIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleDeleteGeometryGeometriesGeometryIdDeleteResponse, HandleDeleteGeometryGeometriesGeometryIdDeleteError, Options<HandleDeleteGeometryGeometriesGeometryIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDeleteGeometryGeometriesGeometryIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetGeometryGeometriesGeometryIdGetQueryKey = (options: Options<HandleGetGeometryGeometriesGeometryIdGetData>) => createQueryKey('handleGetGeometryGeometriesGeometryIdGet', options);

/**
 * Get geometry
 *
 * Get a geometry's detail: status, diagnosis summary, detected openings, simplify proposal, and the caller's role. Poll this after diagnose_geometry, repair_geometry, or simplify_geometry to track progress.
 */
export const handleGetGeometryGeometriesGeometryIdGetOptions = (options: Options<HandleGetGeometryGeometriesGeometryIdGetData>) => queryOptions<HandleGetGeometryGeometriesGeometryIdGetResponse, HandleGetGeometryGeometriesGeometryIdGetError, HandleGetGeometryGeometriesGeometryIdGetResponse, ReturnType<typeof handleGetGeometryGeometriesGeometryIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetGeometryGeometriesGeometryIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetGeometryGeometriesGeometryIdGetQueryKey(options)
});

export const handleGetLineageGeometriesGeometryIdLineageGetQueryKey = (options: Options<HandleGetLineageGeometriesGeometryIdLineageGetData>) => createQueryKey('handleGetLineageGeometriesGeometryIdLineageGet', options);

/**
 * Get geometry lineage
 *
 * Get a geometry's full version chain (uploads, repairs, simplifications) with per-version diagnosis and repair summaries. Returns root_geometry_id, current_geometry_id, and the ordered versions.
 */
export const handleGetLineageGeometriesGeometryIdLineageGetOptions = (options: Options<HandleGetLineageGeometriesGeometryIdLineageGetData>) => queryOptions<HandleGetLineageGeometriesGeometryIdLineageGetResponse, HandleGetLineageGeometriesGeometryIdLineageGetError, HandleGetLineageGeometriesGeometryIdLineageGetResponse, ReturnType<typeof handleGetLineageGeometriesGeometryIdLineageGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetLineageGeometriesGeometryIdLineageGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetLineageGeometriesGeometryIdLineageGetQueryKey(options)
});

export const handleGetGeometryHandoffGeometriesGeometryIdHandoffGetQueryKey = (options: Options<HandleGetGeometryHandoffGeometriesGeometryIdHandoffGetData>) => createQueryKey('handleGetGeometryHandoffGeometriesGeometryIdHandoffGet', options);

/**
 * Get geometry handoff
 *
 * Get what the automatic checks and repair did to a geometry's lineage, for the agent: the outcome, the STEP version to edit from, a reference to its check report, why the repair stopped, the user's stated intent, and whether the agent may start by itself (blocked_reason says why not). Accepts any version's id; viewer access. 409 while the lineage has no state to describe; 403 where the agent tier is off.
 */
export const handleGetGeometryHandoffGeometriesGeometryIdHandoffGetOptions = (options: Options<HandleGetGeometryHandoffGeometriesGeometryIdHandoffGetData>) => queryOptions<HandleGetGeometryHandoffGeometriesGeometryIdHandoffGetResponse, HandleGetGeometryHandoffGeometriesGeometryIdHandoffGetError, HandleGetGeometryHandoffGeometriesGeometryIdHandoffGetResponse, ReturnType<typeof handleGetGeometryHandoffGeometriesGeometryIdHandoffGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetGeometryHandoffGeometriesGeometryIdHandoffGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetGeometryHandoffGeometriesGeometryIdHandoffGetQueryKey(options)
});

export const handleDownloadGeometryGeometriesGeometryIdDownloadGetQueryKey = (options: Options<HandleDownloadGeometryGeometriesGeometryIdDownloadGetData>) => createQueryKey('handleDownloadGeometryGeometriesGeometryIdDownloadGet', options);

/**
 * Download geometry
 *
 * Get a presigned S3 URL to download the geometry's CAD file. The download filename encodes which lineage version the file is.
 */
export const handleDownloadGeometryGeometriesGeometryIdDownloadGetOptions = (options: Options<HandleDownloadGeometryGeometriesGeometryIdDownloadGetData>) => queryOptions<HandleDownloadGeometryGeometriesGeometryIdDownloadGetResponse, HandleDownloadGeometryGeometriesGeometryIdDownloadGetError, HandleDownloadGeometryGeometriesGeometryIdDownloadGetResponse, ReturnType<typeof handleDownloadGeometryGeometriesGeometryIdDownloadGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleDownloadGeometryGeometriesGeometryIdDownloadGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleDownloadGeometryGeometriesGeometryIdDownloadGetQueryKey(options)
});

/**
 * Update geometry visibility
 *
 * Set a geometry's visibility (private, organization, or public) across its whole lineage; owner only. Returns the updated geometry detail.
 */
export const handleUpdateVisibilityGeometriesGeometryIdVisibilityPatchMutation = (options?: Partial<Options<HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchData>>): UseMutationOptions<HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchResponse, HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchError, Options<HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchResponse, HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchError, Options<HandleUpdateVisibilityGeometriesGeometryIdVisibilityPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateVisibilityGeometriesGeometryIdVisibilityPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Rename geometry
 *
 * Rename a geometry's display filename across every version in its lineage (editor access). The stored file and its S3 location are unchanged; download filenames adopt the new name. Returns the updated geometry detail.
 */
export const handleRenameGeometryGeometriesGeometryIdNamePatchMutation = (options?: Partial<Options<HandleRenameGeometryGeometriesGeometryIdNamePatchData>>): UseMutationOptions<HandleRenameGeometryGeometriesGeometryIdNamePatchResponse, HandleRenameGeometryGeometriesGeometryIdNamePatchError, Options<HandleRenameGeometryGeometriesGeometryIdNamePatchData>> => {
    const mutationOptions: UseMutationOptions<HandleRenameGeometryGeometriesGeometryIdNamePatchResponse, HandleRenameGeometryGeometriesGeometryIdNamePatchError, Options<HandleRenameGeometryGeometriesGeometryIdNamePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRenameGeometryGeometriesGeometryIdNamePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetQueryKey = (options: Options<HandleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetData>) => createQueryKey('handleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGet', options);

/**
 * Get geometry design intent
 *
 * Read the engineer's design intent for a geometry. Accepts any version's id and answers for its lineage root: its name, its text (null when none is written) and `can_edit`, whether the caller may replace it. View access on the geometry; 404 otherwise.
 */
export const handleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetOptions = (options: Options<HandleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetData>) => queryOptions<HandleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetResponse, HandleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetError, HandleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetResponse, ReturnType<typeof handleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetGeometryDesignIntentGeometriesGeometryIdDesignIntentGetQueryKey(options)
});

/**
 * Set geometry design intent
 *
 * Replace the engineer's design intent on a geometry: a few sentences on what the part is for, what it must do and what they want to find out. Accepts any version's id and writes the lineage root, so every version reads the same text. Editor access on the root. A blank text clears it; more than 4000 characters is a 422. Last write wins.
 */
export const handlePutDesignIntentGeometriesGeometryIdDesignIntentPutMutation = (options?: Partial<Options<HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutData>>): UseMutationOptions<HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutResponse, HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutError, Options<HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutData>> => {
    const mutationOptions: UseMutationOptions<HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutResponse, HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutError, Options<HandlePutDesignIntentGeometriesGeometryIdDesignIntentPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handlePutDesignIntentGeometriesGeometryIdDesignIntentPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Notify when geometry job finishes
 *
 * Ask to be told once, when the job running on this geometry (diagnosis, repair, simplify or region prep) finishes or fails. Chat needs the chat_session_id to deliver to and the message arrives in that session; email always goes to the caller's own account email and takes no address. Viewer access is enough. If no job is running nothing is written and already_finished is true. Asking twice for the same session is one notification, not two.
 */
export const handleNotifyGeometryGeometriesGeometryIdNotifyPostMutation = (options?: Partial<Options<HandleNotifyGeometryGeometriesGeometryIdNotifyPostData>>): UseMutationOptions<HandleNotifyGeometryGeometriesGeometryIdNotifyPostResponse, HandleNotifyGeometryGeometriesGeometryIdNotifyPostError, Options<HandleNotifyGeometryGeometriesGeometryIdNotifyPostData>> => {
    const mutationOptions: UseMutationOptions<HandleNotifyGeometryGeometriesGeometryIdNotifyPostResponse, HandleNotifyGeometryGeometriesGeometryIdNotifyPostError, Options<HandleNotifyGeometryGeometriesGeometryIdNotifyPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleNotifyGeometryGeometriesGeometryIdNotifyPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm geometry upload
 *
 * Confirm that a direct CAD upload (browser or MCP) reached storage: HEAD the object and mark the geometry available. Call this after PUTting to the URL from get_geometry_upload_url or upload_revision_geometry; diagnose_geometry also confirms when the object is present.
 */
export const handleConfirmUploadGeometriesGeometryIdConfirmUploadPostMutation = (options?: Partial<Options<HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostData>>): UseMutationOptions<HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostResponse, HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostError, Options<HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostData>> => {
    const mutationOptions: UseMutationOptions<HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostResponse, HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostError, Options<HandleConfirmUploadGeometriesGeometryIdConfirmUploadPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleConfirmUploadGeometriesGeometryIdConfirmUploadPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check geometry parts
 *
 * Re-run a wrap geometry's part check. Returns the queued check; poll get_geometry for the result. Refused while a check is already queued.
 */
export const handleCheckGeometryPartsGeometriesGeometryIdPartCheckPostMutation = (options?: Partial<Options<HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostData>>): UseMutationOptions<HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostResponse, HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostError, Options<HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostResponse, HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostError, Options<HandleCheckGeometryPartsGeometriesGeometryIdPartCheckPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCheckGeometryPartsGeometriesGeometryIdPartCheckPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Diagnose geometry
 *
 * Start CAD diagnosis of a geometry (topology checks, quality, opening detection, surface descriptors); returns 202 with status 'diagnosing'. Poll get_geometry until the diagnosis appears. 400 if the geometry is busy, or if it is a repair/simplify version that produced no file.
 */
export const handleDiagnoseGeometriesGeometryIdDiagnosePostMutation = (options?: Partial<Options<HandleDiagnoseGeometriesGeometryIdDiagnosePostData>>): UseMutationOptions<HandleDiagnoseGeometriesGeometryIdDiagnosePostResponse, HandleDiagnoseGeometriesGeometryIdDiagnosePostError, Options<HandleDiagnoseGeometriesGeometryIdDiagnosePostData>> => {
    const mutationOptions: UseMutationOptions<HandleDiagnoseGeometriesGeometryIdDiagnosePostResponse, HandleDiagnoseGeometriesGeometryIdDiagnosePostError, Options<HandleDiagnoseGeometriesGeometryIdDiagnosePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDiagnoseGeometriesGeometryIdDiagnosePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetRegionPrepGeometriesGeometryIdRegionPrepGetQueryKey = (options: Options<HandleGetRegionPrepGeometriesGeometryIdRegionPrepGetData>) => createQueryKey('handleGetRegionPrepGeometriesGeometryIdRegionPrepGet', options);

/**
 * Get region prep
 *
 * Read this geometry's extracted fluid domain BEFORE submitting a mesh, so a wrong extraction is visible before a mesh is paid for. It reports which payload kind it holds, whether the surface is face- or patch-addressed, and the patch groups the extraction derived (e.g. 'wall', 'opening_0', 'fluid_iface'). Pass the mesh params you are about to submit (`mode`, `fluid_passage_mm`) and the response also carries `staleness`: the same sentence create_mesh would reject with, computed by the same rule. Omit them and `staleness_checked` is false — no reason then does NOT mean fresh. Reads the lineage version a mesh would be built on, echoed as `resolved_geometry_id`.
 */
export const handleGetRegionPrepGeometriesGeometryIdRegionPrepGetOptions = (options: Options<HandleGetRegionPrepGeometriesGeometryIdRegionPrepGetData>) => queryOptions<HandleGetRegionPrepGeometriesGeometryIdRegionPrepGetResponse, HandleGetRegionPrepGeometriesGeometryIdRegionPrepGetError, HandleGetRegionPrepGeometriesGeometryIdRegionPrepGetResponse, ReturnType<typeof handleGetRegionPrepGeometriesGeometryIdRegionPrepGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetRegionPrepGeometriesGeometryIdRegionPrepGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetRegionPrepGeometriesGeometryIdRegionPrepGetQueryKey(options)
});

/**
 * Prepare fluid domain
 *
 * Extract the fluid domain as a step of its own, before any mesh request, so the flow-opening and interface patch names exist for boundary-condition assignment. Send `mode` to say which fluid domain — `cht_internal` (+ fluid_passage_mm) for a coolant cavity, `cfd_internal` for a CFD cavity. On a Wrap upload both need probe_fluid_domain to have run on the current file first; 400 says so. create_mesh refuses either mesh on a Wrap upload until this carve has run. Returns 202 with status 'extracting'; poll get_geometry until it returns to 'idle' (or 'error'). Extraction is meaningful only for internal fluid domains: for external flow and ambient-cooled CHT the fluid is the complement of the body, derived while meshing, and 400 says so. 400 also if the geometry is busy, has no file, or names a combination that is declared but not built yet. Detection offers every hole that breaks the surface, so bolt and dowel holes appear alongside the real ports; send `ignored_openings` to say a mouth is not an opening and leave it uncapped. Only the user knows which is which — ask, do not guess: ignoring a real port opens the cavity to ambient and the extraction refuses.
 */
export const handleRegionPrepGeometriesGeometryIdRegionPrepPostMutation = (options?: Partial<Options<HandleRegionPrepGeometriesGeometryIdRegionPrepPostData>>): UseMutationOptions<HandleRegionPrepGeometriesGeometryIdRegionPrepPostResponse, HandleRegionPrepGeometriesGeometryIdRegionPrepPostError, Options<HandleRegionPrepGeometriesGeometryIdRegionPrepPostData>> => {
    const mutationOptions: UseMutationOptions<HandleRegionPrepGeometriesGeometryIdRegionPrepPostResponse, HandleRegionPrepGeometriesGeometryIdRegionPrepPostError, Options<HandleRegionPrepGeometriesGeometryIdRegionPrepPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRegionPrepGeometriesGeometryIdRegionPrepPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Probe fluid domain
 *
 * Step 1 of extracting a fluid domain: look at the CAD and measure it. Detects the openings, reads the bounding box, and derives the narrowest flow passage the part implies — about 15 seconds, and no carve. Send the same `mode` the extraction will use (`cfd_internal` or `cht_internal` on a Wrap upload); do NOT send `fluid_passage_mm`, because this is the step that measures it. Returns 202 with status 'extracting'; poll GET region-prep until it is 'idle' and read the `probe` field. Step 2 (POST region-prep) refuses until this has run on the current file. 400 if the geometry is busy, has no file, or names a fluid domain that is never extracted; the run itself fails with a reason if the part has no detectable openings.
 */
export const handleFluidProbeGeometriesGeometryIdRegionPrepProbePostMutation = (options?: Partial<Options<HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostData>>): UseMutationOptions<HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostResponse, HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostError, Options<HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostData>> => {
    const mutationOptions: UseMutationOptions<HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostResponse, HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostError, Options<HandleFluidProbeGeometriesGeometryIdRegionPrepProbePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleFluidProbeGeometriesGeometryIdRegionPrepProbePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Repair geometry
 *
 * Start automatic CAD repair; creates a new child geometry version and returns it with 202 in status 'repairing'. Poll get_geometry with the new geometry id until it is idle. 400 if the source geometry is busy or has no file.
 */
export const handleRepairGeometriesGeometryIdRepairPostMutation = (options?: Partial<Options<HandleRepairGeometriesGeometryIdRepairPostData>>): UseMutationOptions<HandleRepairGeometriesGeometryIdRepairPostResponse, HandleRepairGeometriesGeometryIdRepairPostError, Options<HandleRepairGeometriesGeometryIdRepairPostData>> => {
    const mutationOptions: UseMutationOptions<HandleRepairGeometriesGeometryIdRepairPostResponse, HandleRepairGeometriesGeometryIdRepairPostError, Options<HandleRepairGeometriesGeometryIdRepairPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRepairGeometriesGeometryIdRepairPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Simplify geometry
 *
 * Propose a CAD simplification (e.g. fuse redundant solids); returns 202 with a new candidate geometry in status 'repairing'. Poll get_geometry on the candidate id until it is 'awaiting_approval' with the proposal, then call approve_simplification or reject_simplification.
 */
export const handleSimplifyGeometriesGeometryIdSimplifyPostMutation = (options?: Partial<Options<HandleSimplifyGeometriesGeometryIdSimplifyPostData>>): UseMutationOptions<HandleSimplifyGeometriesGeometryIdSimplifyPostResponse, HandleSimplifyGeometriesGeometryIdSimplifyPostError, Options<HandleSimplifyGeometriesGeometryIdSimplifyPostData>> => {
    const mutationOptions: UseMutationOptions<HandleSimplifyGeometriesGeometryIdSimplifyPostResponse, HandleSimplifyGeometriesGeometryIdSimplifyPostError, Options<HandleSimplifyGeometriesGeometryIdSimplifyPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleSimplifyGeometriesGeometryIdSimplifyPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Approve simplification
 *
 * Approve a pending CAD-simplification candidate so it becomes the active, meshable version; returns the updated geometry detail. 409 if no simplification is awaiting approval.
 */
export const handleApproveSimplifyGeometriesGeometryIdApprovePostMutation = (options?: Partial<Options<HandleApproveSimplifyGeometriesGeometryIdApprovePostData>>): UseMutationOptions<HandleApproveSimplifyGeometriesGeometryIdApprovePostResponse, HandleApproveSimplifyGeometriesGeometryIdApprovePostError, Options<HandleApproveSimplifyGeometriesGeometryIdApprovePostData>> => {
    const mutationOptions: UseMutationOptions<HandleApproveSimplifyGeometriesGeometryIdApprovePostResponse, HandleApproveSimplifyGeometriesGeometryIdApprovePostError, Options<HandleApproveSimplifyGeometriesGeometryIdApprovePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleApproveSimplifyGeometriesGeometryIdApprovePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject simplification
 *
 * Reject a pending CAD-simplification candidate; it is discarded and the original geometry stays active. Returns the candidate's detail. 409 if no simplification is awaiting approval.
 */
export const handleRejectSimplifyGeometriesGeometryIdRejectPostMutation = (options?: Partial<Options<HandleRejectSimplifyGeometriesGeometryIdRejectPostData>>): UseMutationOptions<HandleRejectSimplifyGeometriesGeometryIdRejectPostResponse, HandleRejectSimplifyGeometriesGeometryIdRejectPostError, Options<HandleRejectSimplifyGeometriesGeometryIdRejectPostData>> => {
    const mutationOptions: UseMutationOptions<HandleRejectSimplifyGeometriesGeometryIdRejectPostResponse, HandleRejectSimplifyGeometriesGeometryIdRejectPostError, Options<HandleRejectSimplifyGeometriesGeometryIdRejectPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRejectSimplifyGeometriesGeometryIdRejectPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetQueryKey = (options: Options<HandleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetData>) => createQueryKey('handleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGet', options);

/**
 * Download geometry diagnosis
 *
 * Get a presigned S3 URL for the geometry's full diagnosis output. 400 if diagnosis has not completed; run diagnose_geometry first.
 */
export const handleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetOptions = (options: Options<HandleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetData>) => queryOptions<HandleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetResponse, HandleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetError, HandleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetResponse, ReturnType<typeof handleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleDownloadDiagnosisGeometriesGeometryIdDiagnosisDownloadGetQueryKey(options)
});

export const handleGetSurfacesGeometriesGeometryIdSurfacesGetQueryKey = (options: Options<HandleGetSurfacesGeometriesGeometryIdSurfacesGetData>) => createQueryKey('handleGetSurfacesGeometriesGeometryIdSurfacesGet', options);

/**
 * Get surfaces
 *
 * Get per-face surface descriptors for a geometry: face index, centroid, normal, area, and STL triangle range. Returns 202 pending while diagnosis or repair runs; 400 if diagnosis has never been run.
 */
export const handleGetSurfacesGeometriesGeometryIdSurfacesGetOptions = (options: Options<HandleGetSurfacesGeometriesGeometryIdSurfacesGetData>) => queryOptions<HandleGetSurfacesGeometriesGeometryIdSurfacesGetResponse, HandleGetSurfacesGeometriesGeometryIdSurfacesGetError, HandleGetSurfacesGeometriesGeometryIdSurfacesGetResponse, ReturnType<typeof handleGetSurfacesGeometriesGeometryIdSurfacesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSurfacesGeometriesGeometryIdSurfacesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSurfacesGeometriesGeometryIdSurfacesGetQueryKey(options)
});

export const handleGetEnclosureGeometriesGeometryIdEnclosureGetQueryKey = (options: Options<HandleGetEnclosureGeometriesGeometryIdEnclosureGetData>) => createQueryKey('handleGetEnclosureGeometriesGeometryIdEnclosureGet', options);

/**
 * Get enclosure
 *
 * Preview the external-flow enclosure box computed from a geometry's surface descriptors, without meshing. Returns domain bounds plus inlet, outlet, and farfield faces. Sizing factors scale the box to the body; 400 until diagnosis has run.
 */
export const handleGetEnclosureGeometriesGeometryIdEnclosureGetOptions = (options: Options<HandleGetEnclosureGeometriesGeometryIdEnclosureGetData>) => queryOptions<HandleGetEnclosureGeometriesGeometryIdEnclosureGetResponse, HandleGetEnclosureGeometriesGeometryIdEnclosureGetError, HandleGetEnclosureGeometriesGeometryIdEnclosureGetResponse, ReturnType<typeof handleGetEnclosureGeometriesGeometryIdEnclosureGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetEnclosureGeometriesGeometryIdEnclosureGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetEnclosureGeometriesGeometryIdEnclosureGetQueryKey(options)
});

export const handleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetQueryKey = (options: Options<HandleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetData>) => createQueryKey('handleGetSurfacesStlGeometriesGeometryIdSurfacesStlGet', options);

/**
 * Get surfaces STL
 *
 * Get a presigned S3 URL for the coarse descriptor STL used for 3D rendering and surface picking; triangle ranges match get_surfaces. Returns 202 pending while diagnosis or repair runs; 400 if not yet generated.
 */
export const handleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetOptions = (options: Options<HandleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetData>) => queryOptions<HandleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetResponse, HandleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetError, HandleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetResponse, ReturnType<typeof handleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSurfacesStlGeometriesGeometryIdSurfacesStlGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSurfacesStlGeometriesGeometryIdSurfacesStlGetQueryKey(options)
});

export const handleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetQueryKey = (options: Options<HandleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetData>) => createQueryKey('handleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGet', options);

/**
 * Get surfaces JSON
 *
 * Get a presigned S3 URL for the surface descriptor JSON: the same per-face data as get_surfaces, fetched directly from S3. Returns 202 pending while diagnosis or repair runs; 400 if not yet available.
 */
export const handleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetOptions = (options: Options<HandleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetData>) => queryOptions<HandleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetResponse, HandleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetError, HandleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetResponse, ReturnType<typeof handleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSurfacesJsonGeometriesGeometryIdSurfacesJsonGetQueryKey(options)
});

export const handleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetQueryKey = (options: Options<HandleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetData>) => createQueryKey('handleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGet', options);

/**
 * Get surfaces fine STL
 *
 * Get a presigned S3 URL for the fine, denser surface STL used for detailed render previews. Returns 202 pending while the fine descriptor is still being generated (async after the geometry goes IDLE); 404 for STL-input geometries, which never get a fine descriptor.
 */
export const handleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetOptions = (options: Options<HandleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetData>) => queryOptions<HandleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetResponse, HandleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetError, HandleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetResponse, ReturnType<typeof handleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSurfacesFineStlGeometriesGeometryIdSurfacesFineStlGetQueryKey(options)
});

export const handleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetQueryKey = (options: Options<HandleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetData>) => createQueryKey('handleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGet', options);

/**
 * Get surfaces fine JSON
 *
 * Get a presigned S3 URL for the fine surface descriptor JSON matching the fine STL's denser tessellation. Returns 202 pending while the fine descriptor is still being generated (async after the geometry goes IDLE); 404 for STL-input geometries, which never get a fine descriptor.
 */
export const handleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetOptions = (options: Options<HandleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetData>) => queryOptions<HandleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetResponse, HandleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetError, HandleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetResponse, ReturnType<typeof handleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSurfacesFineJsonGeometriesGeometryIdSurfacesFineJsonGetQueryKey(options)
});

export const handleGetGeometryViewGeometriesGeometryIdViewsLodGetQueryKey = (options: Options<HandleGetGeometryViewGeometriesGeometryIdViewsLodGetData>) => createQueryKey('handleGetGeometryViewGeometriesGeometryIdViewsLodGet', options);

/**
 * Get geometry view
 *
 * Get the latest published face-catalog view for a geometry at the given level of detail ('pick', 'detail', 'fine', or 'cavity'). Returns view metadata (byte size, face count, index key space, revision) plus a presigned S3 URL to the gzip-encoded JSON payload. A detail-lod miss mints the view on read for pre-views geometries with descriptors; other lods 404 until published.
 */
export const handleGetGeometryViewGeometriesGeometryIdViewsLodGetOptions = (options: Options<HandleGetGeometryViewGeometriesGeometryIdViewsLodGetData>) => queryOptions<HandleGetGeometryViewGeometriesGeometryIdViewsLodGetResponse, HandleGetGeometryViewGeometriesGeometryIdViewsLodGetError, HandleGetGeometryViewGeometriesGeometryIdViewsLodGetResponse, ReturnType<typeof handleGetGeometryViewGeometriesGeometryIdViewsLodGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetGeometryViewGeometriesGeometryIdViewsLodGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetGeometryViewGeometriesGeometryIdViewsLodGetQueryKey(options)
});

export const handleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetQueryKey = (options: Options<HandleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetData>) => createQueryKey('handleGetFaceLabelsGeometriesGeometryIdFaceLabelsGet', options);

/**
 * Get face labels
 *
 * Get the persisted face labels for a geometry. Returns a sparse {face_index: label} map in the canonical surface-descriptor index space (or {face_key: label} when key_space is 'canonical'), plus the revision to send back as expected_revision when saving, and the surface_source the keys were captured against (null on a row saved before that field existed). Body-sourced labels are translated onto the latest detail catalog's face_keys when the identity-correspondence chain allows; otherwise the stored form is returned with stale=true when a newer catalog revision broke the mapping. Cavity-sourced labels are always returned untranslated with stale=false — the detail catalog is the body's, so its face_keys cannot name a cavity face. Returns revision 0 with an empty map when nothing has been saved.
 */
export const handleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetOptions = (options: Options<HandleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetData>) => queryOptions<HandleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetResponse, HandleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetError, HandleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetResponse, ReturnType<typeof handleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetFaceLabelsGeometriesGeometryIdFaceLabelsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetFaceLabelsGeometriesGeometryIdFaceLabelsGetQueryKey(options)
});

/**
 * Save face labels
 *
 * Replace the persisted face labels for a geometry (editor and up). Labels may be keyed by face_index (key_space 'ordinal') or by face_key (key_space 'canonical', ENG-1260). Labels apply to every subsequent mesh run without resending them; explicit face_tags in a mesh request win over a stored label for the same face. expected_revision must match the stored revision or the save fails with 409 carrying the current revision; bodies over 700000 uncompressed bytes fail with 413.
 */
export const handlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutMutation = (options?: Partial<Options<HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutData>>): UseMutationOptions<HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutResponse, HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutError, Options<HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutData>> => {
    const mutationOptions: UseMutationOptions<HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutResponse, HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutError, Options<HandlePutFaceLabelsGeometriesGeometryIdFaceLabelsPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handlePutFaceLabelsGeometriesGeometryIdFaceLabelsPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetQueryKey = (options: Options<HandleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetData>) => createQueryKey('handleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGet', options);

/**
 * Get structural bodies
 *
 * Get the persisted structural body assignment for a geometry (ENG-2216): one entry per classified body with its display label and its member / fastener / excluded role, plus the revision to send back as expected_revision when saving. Entries are keyed by body_index — the 0-based OCC traversal position the geometry's volume descriptors carry, and the `<i>` in the deck's `Volume_<i>` element set. Returns revision 0 with an empty list when nothing has been saved.
 */
export const handleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetOptions = (options: Options<HandleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetData>) => queryOptions<HandleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetResponse, HandleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetError, HandleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetResponse, ReturnType<typeof handleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetStructuralBodiesGeometriesGeometryIdStructuralBodiesGetQueryKey(options)
});

/**
 * Save structural bodies
 *
 * Replace the persisted structural body assignment for a geometry (editor and up). Replace-all: an empty `assignments` list clears every assignment. Labels are display text — the solver-side element set stays `Volume_<body_index>`, so renaming a body never breaks a saved material or boundary-condition target. expected_revision must match the stored revision or the save fails with 409 carrying the current revision.
 */
export const handlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutMutation = (options?: Partial<Options<HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutData>>): UseMutationOptions<HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutResponse, HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutError, Options<HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutData>> => {
    const mutationOptions: UseMutationOptions<HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutResponse, HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutError, Options<HandlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handlePutStructuralBodiesGeometriesGeometryIdStructuralBodiesPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetQueryKey = (options: Options<HandleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetData>) => createQueryKey('handleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGet', options);

/**
 * Get fluid domain STEP
 *
 * Get a presigned S3 URL for the fluid domain STEP extracted from an internal-flow geometry during diagnosis. 400 if no fluid domain has been extracted yet.
 */
export const handleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetOptions = (options: Options<HandleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetData>) => queryOptions<HandleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetResponse, HandleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetError, HandleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetResponse, ReturnType<typeof handleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetFluidDomainStepGeometriesGeometryIdFluidDomainStepGetQueryKey(options)
});

export const handleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetQueryKey = (options: Options<HandleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetData>) => createQueryKey('handleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGet', options);

/**
 * Get fluid domain STL
 *
 * Get a presigned S3 URL for the fluid domain STL extracted from an internal-flow geometry during diagnosis. 400 if no fluid domain has been extracted yet.
 */
export const handleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetOptions = (options: Options<HandleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetData>) => queryOptions<HandleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetResponse, HandleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetError, HandleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetResponse, ReturnType<typeof handleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetFluidDomainStlGeometriesGeometryIdFluidDomainStlGetQueryKey(options)
});

export const handleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetQueryKey = (options: Options<HandleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetData>) => createQueryKey('handleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGet', options);

/**
 * Get region prep STL
 *
 * Get a presigned S3 URL for the surface a standalone fluid extraction produced. This is the wrap path's counterpart to fluid-domain/stl, which serves only the OCC B-rep cut and so 400s forever on a wrap-prepped part. Serves whichever payload was stored; to know whether it is a fluid-only cavity ('cavity_wrap') or a fluid+solid tagged surface ('cht_region_set'), read `extraction.kind` from GET region-prep — but fetch this URL for that response's `resolved_geometry_id`, because this route serves the row you name while that one describes the row a mesh would be built on, and on a grown lineage they differ. The surface is featureless by construction, so there are no face descriptors to pair with it — its solid-block names are the patch groups listed in that same response. 400 if no extraction has been persisted.
 */
export const handleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetOptions = (options: Options<HandleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetData>) => queryOptions<HandleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetResponse, HandleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetError, HandleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetResponse, ReturnType<typeof handleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetRegionPrepStlGeometriesGeometryIdRegionPrepStlGetQueryKey(options)
});

export const handleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetQueryKey = (options: Options<HandleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetData>) => createQueryKey('handleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGet', options);

/**
 * Get fluid domain surfaces
 *
 * Get per-face surface descriptors for the extracted fluid domain of an internal-flow geometry, in the same format as get_surfaces. 400 if no fluid domain has been extracted yet.
 */
export const handleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetOptions = (options: Options<HandleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetData>) => queryOptions<HandleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetResponse, HandleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetError, HandleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetResponse, ReturnType<typeof handleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetFluidDomainSurfacesGeometriesGeometryIdFluidDomainSurfacesGetQueryKey(options)
});

export const handleGetSharingGeometriesGeometryIdSharingGetQueryKey = (options: Options<HandleGetSharingGeometriesGeometryIdSharingGetData>) => createQueryKey('handleGetSharingGeometriesGeometryIdSharingGet', options);

/**
 * Get sharing
 *
 * Get a geometry's sharing settings: lineage-wide visibility, link role, owner email, and per-person share grants. Owner only.
 */
export const handleGetSharingGeometriesGeometryIdSharingGetOptions = (options: Options<HandleGetSharingGeometriesGeometryIdSharingGetData>) => queryOptions<HandleGetSharingGeometriesGeometryIdSharingGetResponse, HandleGetSharingGeometriesGeometryIdSharingGetError, HandleGetSharingGeometriesGeometryIdSharingGetResponse, ReturnType<typeof handleGetSharingGeometriesGeometryIdSharingGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSharingGeometriesGeometryIdSharingGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSharingGeometriesGeometryIdSharingGetQueryKey(options)
});

/**
 * Update sharing
 *
 * Set a geometry's lineage-wide visibility (private, organization, or public) and the role its share link grants (viewer, commenter, or editor). Owner only; returns the updated sharing settings.
 */
export const handleUpdateSharingGeometriesGeometryIdSharingPutMutation = (options?: Partial<Options<HandleUpdateSharingGeometriesGeometryIdSharingPutData>>): UseMutationOptions<HandleUpdateSharingGeometriesGeometryIdSharingPutResponse, HandleUpdateSharingGeometriesGeometryIdSharingPutError, Options<HandleUpdateSharingGeometriesGeometryIdSharingPutData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateSharingGeometriesGeometryIdSharingPutResponse, HandleUpdateSharingGeometriesGeometryIdSharingPutError, Options<HandleUpdateSharingGeometriesGeometryIdSharingPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateSharingGeometriesGeometryIdSharingPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create invite
 *
 * Invite a person by email to a geometry's lineage with a role (viewer, commenter, or editor), or refresh an existing grant. Owner only; sends a best-effort notification email and returns the share entry plus email_sent.
 */
export const handleCreateInviteGeometriesGeometryIdSharingInvitesPostMutation = (options?: Partial<Options<HandleCreateInviteGeometriesGeometryIdSharingInvitesPostData>>): UseMutationOptions<HandleCreateInviteGeometriesGeometryIdSharingInvitesPostResponse, HandleCreateInviteGeometriesGeometryIdSharingInvitesPostError, Options<HandleCreateInviteGeometriesGeometryIdSharingInvitesPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCreateInviteGeometriesGeometryIdSharingInvitesPostResponse, HandleCreateInviteGeometriesGeometryIdSharingInvitesPostError, Options<HandleCreateInviteGeometriesGeometryIdSharingInvitesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCreateInviteGeometriesGeometryIdSharingInvitesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete invite
 *
 * Revoke a person's share grant on a geometry's lineage (owner only); returns 204 with no body. 404 if no grant exists for that email.
 */
export const handleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteMutation = (options?: Partial<Options<HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteData>>): UseMutationOptions<HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteResponse, HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteError, Options<HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteResponse, HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteError, Options<HandleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDeleteInviteGeometriesGeometryIdSharingInvitesInviteEmailDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update invite
 *
 * Change the role of an existing per-person share grant on a geometry's lineage. Owner only; returns the updated share entry. 404 if no grant exists for that email.
 */
export const handleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchMutation = (options?: Partial<Options<HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchData>>): UseMutationOptions<HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchResponse, HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchError, Options<HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchResponse, HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchError, Options<HandleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateInviteGeometriesGeometryIdSharingInvitesInviteEmailPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get geometry edit access
 *
 * Internal transport for authorized interactive geometry editing.
 */
export const handleGeometryEditAccessGeometriesGeometryIdEditAccessPostMutation = (options?: Partial<Options<HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostData>>): UseMutationOptions<HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostResponse, HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostError, Options<HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostData>> => {
    const mutationOptions: UseMutationOptions<HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostResponse, HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostError, Options<HandleGeometryEditAccessGeometriesGeometryIdEditAccessPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleGeometryEditAccessGeometriesGeometryIdEditAccessPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get geometry edit upload URL
 */
export const handleGeometryEditUploadGeometryEditsEditIdUploadAccessPostMutation = (options?: Partial<Options<HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostData>>): UseMutationOptions<HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostResponse, HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostError, Options<HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostData>> => {
    const mutationOptions: UseMutationOptions<HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostResponse, HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostError, Options<HandleGeometryEditUploadGeometryEditsEditIdUploadAccessPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleGeometryEditUploadGeometryEditsEditIdUploadAccessPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish geometry edit
 */
export const handleGeometryEditFinalizeGeometryEditsEditIdFinalizePostMutation = (options?: Partial<Options<HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostData>>): UseMutationOptions<HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostResponse, HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostError, Options<HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostData>> => {
    const mutationOptions: UseMutationOptions<HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostResponse, HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostError, Options<HandleGeometryEditFinalizeGeometryEditsEditIdFinalizePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleGeometryEditFinalizeGeometryEditsEditIdFinalizePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGeometryEditReceiptGeometryEditsEditIdPublicationGetQueryKey = (options: Options<HandleGeometryEditReceiptGeometryEditsEditIdPublicationGetData>) => createQueryKey('handleGeometryEditReceiptGeometryEditsEditIdPublicationGet', options);

/**
 * Get geometry edit receipt
 */
export const handleGeometryEditReceiptGeometryEditsEditIdPublicationGetOptions = (options: Options<HandleGeometryEditReceiptGeometryEditsEditIdPublicationGetData>) => queryOptions<HandleGeometryEditReceiptGeometryEditsEditIdPublicationGetResponse, HandleGeometryEditReceiptGeometryEditsEditIdPublicationGetError, HandleGeometryEditReceiptGeometryEditsEditIdPublicationGetResponse, ReturnType<typeof handleGeometryEditReceiptGeometryEditsEditIdPublicationGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGeometryEditReceiptGeometryEditsEditIdPublicationGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGeometryEditReceiptGeometryEditsEditIdPublicationGetQueryKey(options)
});

/**
 * Cancel geometry edit
 */
export const handleGeometryEditCancelGeometryEditsEditIdCancelPostMutation = (options?: Partial<Options<HandleGeometryEditCancelGeometryEditsEditIdCancelPostData>>): UseMutationOptions<HandleGeometryEditCancelGeometryEditsEditIdCancelPostResponse, HandleGeometryEditCancelGeometryEditsEditIdCancelPostError, Options<HandleGeometryEditCancelGeometryEditsEditIdCancelPostData>> => {
    const mutationOptions: UseMutationOptions<HandleGeometryEditCancelGeometryEditsEditIdCancelPostResponse, HandleGeometryEditCancelGeometryEditsEditIdCancelPostError, Options<HandleGeometryEditCancelGeometryEditsEditIdCancelPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleGeometryEditCancelGeometryEditsEditIdCancelPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Release geometry edit
 */
export const handleGeometryEditReleaseGeometryEditsEditIdReleasePostMutation = (options?: Partial<Options<HandleGeometryEditReleaseGeometryEditsEditIdReleasePostData>>): UseMutationOptions<HandleGeometryEditReleaseGeometryEditsEditIdReleasePostResponse, HandleGeometryEditReleaseGeometryEditsEditIdReleasePostError, Options<HandleGeometryEditReleaseGeometryEditsEditIdReleasePostData>> => {
    const mutationOptions: UseMutationOptions<HandleGeometryEditReleaseGeometryEditsEditIdReleasePostResponse, HandleGeometryEditReleaseGeometryEditsEditIdReleasePostError, Options<HandleGeometryEditReleaseGeometryEditsEditIdReleasePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleGeometryEditReleaseGeometryEditsEditIdReleasePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get geometry preview upload URL
 */
export const handleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostMutation = (options?: Partial<Options<HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostData>>): UseMutationOptions<HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostResponse, HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostError, Options<HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostData>> => {
    const mutationOptions: UseMutationOptions<HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostResponse, HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostError, Options<HandleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleGeometryPreviewUploadGeometryEditsEditIdPreviewUploadAccessPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetQueryKey = (options: Options<HandleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetData>) => createQueryKey('handleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGet', options);

/**
 * Download geometry preview
 */
export const handleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetOptions = (options: Options<HandleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetData>) => queryOptions<HandleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetResponse, HandleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetError, HandleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetResponse, ReturnType<typeof handleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGeometryPreviewDownloadGeometryEditsEditIdPreviewsRevisionGetQueryKey(options)
});

/**
 * Create mesh
 *
 * Start meshing a geometry. Returns 202 with the new mesh id immediately; meshing runs in the background, so poll get_mesh for status and results. Meshing targets the latest repaired (IDLE) version in the geometry's lineage, not necessarily the exact id passed. Wrap cfd_internal/cht_internal: run region_prep_geometry first.
 */
export const handleCreateMeshGeometriesGeometryIdMeshPostMutation = (options?: Partial<Options<HandleCreateMeshGeometriesGeometryIdMeshPostData>>): UseMutationOptions<HandleCreateMeshGeometriesGeometryIdMeshPostResponse, HandleCreateMeshGeometriesGeometryIdMeshPostError, Options<HandleCreateMeshGeometriesGeometryIdMeshPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCreateMeshGeometriesGeometryIdMeshPostResponse, HandleCreateMeshGeometriesGeometryIdMeshPostError, Options<HandleCreateMeshGeometriesGeometryIdMeshPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCreateMeshGeometriesGeometryIdMeshPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refine mesh
 *
 * Refine a completed mesh with region-based refinement. Returns 202 with the new mesh id immediately and runs in the background; poll get_mesh. The new mesh links to the source; 400 if the source mesh output is not ready.
 */
export const handleRefineMeshMeshesMeshIdRefinePostMutation = (options?: Partial<Options<HandleRefineMeshMeshesMeshIdRefinePostData>>): UseMutationOptions<HandleRefineMeshMeshesMeshIdRefinePostResponse, HandleRefineMeshMeshesMeshIdRefinePostError, Options<HandleRefineMeshMeshesMeshIdRefinePostData>> => {
    const mutationOptions: UseMutationOptions<HandleRefineMeshMeshesMeshIdRefinePostResponse, HandleRefineMeshMeshesMeshIdRefinePostError, Options<HandleRefineMeshMeshesMeshIdRefinePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRefineMeshMeshesMeshIdRefinePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListGeometryMeshesGeometriesGeometryIdMeshesGetQueryKey = (options: Options<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData>) => createQueryKey('handleListGeometryMeshesGeometriesGeometryIdMeshesGet', options);

/**
 * List geometry meshes
 *
 * List the meshes created for a geometry, newest first, paginated. Set lineage=true to include meshes from every version in the geometry's lineage.
 */
export const handleListGeometryMeshesGeometriesGeometryIdMeshesGetOptions = (options: Options<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData>) => queryOptions<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetResponse, HandleListGeometryMeshesGeometriesGeometryIdMeshesGetError, HandleListGeometryMeshesGeometriesGeometryIdMeshesGetResponse, ReturnType<typeof handleListGeometryMeshesGeometriesGeometryIdMeshesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListGeometryMeshesGeometriesGeometryIdMeshesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListGeometryMeshesGeometriesGeometryIdMeshesGetQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const handleListGeometryMeshesGeometriesGeometryIdMeshesGetInfiniteQueryKey = (options: Options<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData>): QueryKey<Options<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData>> => createQueryKey('handleListGeometryMeshesGeometriesGeometryIdMeshesGet', options, true);

/**
 * List geometry meshes
 *
 * List the meshes created for a geometry, newest first, paginated. Set lineage=true to include meshes from every version in the geometry's lineage.
 */
export const handleListGeometryMeshesGeometriesGeometryIdMeshesGetInfiniteOptions = (options: Options<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData>) => infiniteQueryOptions<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetResponse, HandleListGeometryMeshesGeometriesGeometryIdMeshesGetError, InfiniteData<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetResponse>, QueryKey<Options<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData>>, string | null | Pick<QueryKey<Options<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<HandleListGeometryMeshesGeometriesGeometryIdMeshesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await handleListGeometryMeshesGeometriesGeometryIdMeshesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListGeometryMeshesGeometriesGeometryIdMeshesGetInfiniteQueryKey(options)
});

export const handleGetMeshMeshesMeshIdGetQueryKey = (options: Options<HandleGetMeshMeshesMeshIdGetData>) => createQueryKey('handleGetMeshMeshesMeshIdGet', options);

/**
 * Get mesh
 *
 * Get a mesh's detail: status, params, quality metrics, and pipeline result. Poll this after create_mesh or refine_mesh to track progress.
 */
export const handleGetMeshMeshesMeshIdGetOptions = (options: Options<HandleGetMeshMeshesMeshIdGetData>) => queryOptions<HandleGetMeshMeshesMeshIdGetResponse, HandleGetMeshMeshesMeshIdGetError, HandleGetMeshMeshesMeshIdGetResponse, ReturnType<typeof handleGetMeshMeshesMeshIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetMeshMeshesMeshIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetMeshMeshesMeshIdGetQueryKey(options)
});

export const handleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetQueryKey = (options: Options<HandleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetData>) => createQueryKey('handleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGet', options);

/**
 * Get mesh bonded proposals
 *
 * Read the contacts a completed FEA mesh left unjoined as review-only bonded tie proposals, each naming its two Faying_ sets and a gap-based tolerance. No study is changed; select the joints that cannot open or slip, then confirm_mesh_bonded_proposals against this revision.
 */
export const handleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetOptions = (options: Options<HandleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetData>) => queryOptions<HandleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetResponse, HandleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetError, HandleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetResponse, ReturnType<typeof handleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetMeshBondedProposalsMeshesMeshIdBondedProposalsGetQueryKey(options)
});

export const handleGetMeshPatchesMeshesMeshIdPatchesGetQueryKey = (options: Options<HandleGetMeshPatchesMeshesMeshIdPatchesGetData>) => createQueryKey('handleGetMeshPatchesMeshesMeshIdPatchesGet', options);

/**
 * Get mesh patches
 *
 * List the polyMesh patches available for boundary-condition assignment, grouped by region. CHT interface patches are excluded; regions is empty for meshes without patch metadata (no polyMesh output, e.g. an untagged tet mesh, or not yet completed).
 */
export const handleGetMeshPatchesMeshesMeshIdPatchesGetOptions = (options: Options<HandleGetMeshPatchesMeshesMeshIdPatchesGetData>) => queryOptions<HandleGetMeshPatchesMeshesMeshIdPatchesGetResponse, HandleGetMeshPatchesMeshesMeshIdPatchesGetError, HandleGetMeshPatchesMeshesMeshIdPatchesGetResponse, ReturnType<typeof handleGetMeshPatchesMeshesMeshIdPatchesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetMeshPatchesMeshesMeshIdPatchesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetMeshPatchesMeshesMeshIdPatchesGetQueryKey(options)
});

export const handleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetQueryKey = (options: Options<HandleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetData>) => createQueryKey('handleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGet', options);

/**
 * Get mesh boundary curves
 *
 * Get each labeled face's boundary edges for edge-load assignment. Only FEA-solid tet meshes carry this data; any other mesh returns an empty by_face_label map.
 */
export const handleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetOptions = (options: Options<HandleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetData>) => queryOptions<HandleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetResponse, HandleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetError, HandleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetResponse, ReturnType<typeof handleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetMeshBoundaryCurvesMeshesMeshIdBoundaryCurvesGetQueryKey(options)
});

/**
 * Cancel mesh
 *
 * Cancel a pending or running mesh job and best-effort stop its compute task. Returns the updated mesh detail; 409 if the mesh is not in a cancellable state.
 */
export const handleCancelMeshMeshesMeshIdCancelPostMutation = (options?: Partial<Options<HandleCancelMeshMeshesMeshIdCancelPostData>>): UseMutationOptions<HandleCancelMeshMeshesMeshIdCancelPostResponse, HandleCancelMeshMeshesMeshIdCancelPostError, Options<HandleCancelMeshMeshesMeshIdCancelPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCancelMeshMeshesMeshIdCancelPostResponse, HandleCancelMeshMeshesMeshIdCancelPostError, Options<HandleCancelMeshMeshesMeshIdCancelPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCancelMeshMeshesMeshIdCancelPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Notify when mesh finishes
 *
 * Ask to be told once, when this mesh job finishes (completed, failed or cancelled). Chat needs the chat_session_id to deliver to and the message arrives in that session; email always goes to the caller's own account email and takes no address. Viewer access is enough. If the mesh has already finished nothing is written and already_finished is true. Asking twice for the same session is one notification, not two.
 */
export const handleNotifyMeshMeshesMeshIdNotifyPostMutation = (options?: Partial<Options<HandleNotifyMeshMeshesMeshIdNotifyPostData>>): UseMutationOptions<HandleNotifyMeshMeshesMeshIdNotifyPostResponse, HandleNotifyMeshMeshesMeshIdNotifyPostError, Options<HandleNotifyMeshMeshesMeshIdNotifyPostData>> => {
    const mutationOptions: UseMutationOptions<HandleNotifyMeshMeshesMeshIdNotifyPostResponse, HandleNotifyMeshMeshesMeshIdNotifyPostError, Options<HandleNotifyMeshMeshesMeshIdNotifyPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleNotifyMeshMeshesMeshIdNotifyPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleDownloadMeshMeshesMeshIdDownloadGetQueryKey = (options: Options<HandleDownloadMeshMeshesMeshIdDownloadGetData>) => createQueryKey('handleDownloadMeshMeshesMeshIdDownloadGet', options);

/**
 * Download mesh
 *
 * Get a presigned S3 download URL for one of a mesh's output files, selected by the file query param (solver formats, surface STL, quality report, logs bundle). 400 if that output is not ready.
 */
export const handleDownloadMeshMeshesMeshIdDownloadGetOptions = (options: Options<HandleDownloadMeshMeshesMeshIdDownloadGetData>) => queryOptions<HandleDownloadMeshMeshesMeshIdDownloadGetResponse, HandleDownloadMeshMeshesMeshIdDownloadGetError, HandleDownloadMeshMeshesMeshIdDownloadGetResponse, ReturnType<typeof handleDownloadMeshMeshesMeshIdDownloadGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleDownloadMeshMeshesMeshIdDownloadGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleDownloadMeshMeshesMeshIdDownloadGetQueryKey(options)
});

export const handleGetMeshFaceTagsMeshesMeshIdFaceTagsGetQueryKey = (options: Options<HandleGetMeshFaceTagsMeshesMeshIdFaceTagsGetData>) => createQueryKey('handleGetMeshFaceTagsMeshesMeshIdFaceTagsGet', options);

/**
 * Get mesh face tags
 *
 * Get a presigned S3 URL for the mesh's S3-backed face_tags array (the offload for high-face models submitted via face_tags_s3_key). 404 if the mesh carries face_tags inline instead — read mesh_params.face_tags.
 */
export const handleGetMeshFaceTagsMeshesMeshIdFaceTagsGetOptions = (options: Options<HandleGetMeshFaceTagsMeshesMeshIdFaceTagsGetData>) => queryOptions<HandleGetMeshFaceTagsMeshesMeshIdFaceTagsGetResponse, HandleGetMeshFaceTagsMeshesMeshIdFaceTagsGetError, HandleGetMeshFaceTagsMeshesMeshIdFaceTagsGetResponse, ReturnType<typeof handleGetMeshFaceTagsMeshesMeshIdFaceTagsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetMeshFaceTagsMeshesMeshIdFaceTagsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetMeshFaceTagsMeshesMeshIdFaceTagsGetQueryKey(options)
});

export const handleGetMeshLogsMeshesMeshIdLogsGetQueryKey = (options: Options<HandleGetMeshLogsMeshesMeshIdLogsGetData>) => createQueryKey('handleGetMeshLogsMeshesMeshIdLogsGet', options);

/**
 * Get mesh logs
 *
 * Get the tail of each OpenFOAM per-command log (blockMesh, snappyHexMesh, checkMesh) as inline text, without downloading the logs tarball. Hex (snappyHexMesh/cfMesh) meshes only; 400 when no logs bundle exists.
 */
export const handleGetMeshLogsMeshesMeshIdLogsGetOptions = (options: Options<HandleGetMeshLogsMeshesMeshIdLogsGetData>) => queryOptions<HandleGetMeshLogsMeshesMeshIdLogsGetResponse, HandleGetMeshLogsMeshesMeshIdLogsGetError, HandleGetMeshLogsMeshesMeshIdLogsGetResponse, ReturnType<typeof handleGetMeshLogsMeshesMeshIdLogsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetMeshLogsMeshesMeshIdLogsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetMeshLogsMeshesMeshIdLogsGetQueryKey(options)
});

export const handleGetMeshRetryChainMeshesMeshIdRetryChainGetQueryKey = (options: Options<HandleGetMeshRetryChainMeshesMeshIdRetryChainGetData>) => createQueryKey('handleGetMeshRetryChainMeshesMeshIdRetryChainGet', options);

/**
 * Get mesh retry chain
 *
 * Get the mesh's AI-retry chain. Each attempt carries its spawning decision's param adjustments, decisions made on it, key quality metrics, and the before/after quality delta. Viewer-readable like mesh detail.
 */
export const handleGetMeshRetryChainMeshesMeshIdRetryChainGetOptions = (options: Options<HandleGetMeshRetryChainMeshesMeshIdRetryChainGetData>) => queryOptions<HandleGetMeshRetryChainMeshesMeshIdRetryChainGetResponse, HandleGetMeshRetryChainMeshesMeshIdRetryChainGetError, HandleGetMeshRetryChainMeshesMeshIdRetryChainGetResponse, ReturnType<typeof handleGetMeshRetryChainMeshesMeshIdRetryChainGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetMeshRetryChainMeshesMeshIdRetryChainGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetMeshRetryChainMeshesMeshIdRetryChainGetQueryKey(options)
});

/**
 * Dismiss retry decision
 *
 * Resolve a proposed retry decision without dispatching: plain dismiss, `flag` for review, or `accept_below_policy` (the durable human override recording that a below-policy mesh is acceptable). Every body field defaults, so `{}` dismisses plainly, but the body itself is required (an absent body is a 422). 404 unknown decision; 409 when the decision is no longer `proposed`.
 */
export const handleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostMutation = (options?: Partial<Options<HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostData>>): UseMutationOptions<HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostResponse, HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostError, Options<HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostData>> => {
    const mutationOptions: UseMutationOptions<HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostResponse, HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostError, Options<HandleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDismissRetryDecisionMeshesMeshIdRetryDecisionsDecisionIdDismissPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry mesh with AI
 *
 * Hand a terminal mesh to the retry advisor. The verdict is recorded as a human decision on the mesh and, when dispatchable, a new attempt is enqueued (202 = the NEW mesh). 409 when nothing was dispatched (declined / low-confidence / proposal refused / not retryable — the message carries the advisor's diagnosis); 402 when the workspace or user has no access to the advisor; 502 when the advisor is unavailable.
 */
export const handleRetryMeshAiMeshesMeshIdRetryAiPostMutation = (options?: Partial<Options<HandleRetryMeshAiMeshesMeshIdRetryAiPostData>>): UseMutationOptions<HandleRetryMeshAiMeshesMeshIdRetryAiPostResponse, HandleRetryMeshAiMeshesMeshIdRetryAiPostError, Options<HandleRetryMeshAiMeshesMeshIdRetryAiPostData>> => {
    const mutationOptions: UseMutationOptions<HandleRetryMeshAiMeshesMeshIdRetryAiPostResponse, HandleRetryMeshAiMeshesMeshIdRetryAiPostError, Options<HandleRetryMeshAiMeshesMeshIdRetryAiPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRetryMeshAiMeshesMeshIdRetryAiPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetSimulationSimulationsSimulationIdGetQueryKey = (options: Options<HandleGetSimulationSimulationsSimulationIdGetData>) => createQueryKey('handleGetSimulationSimulationsSimulationIdGet', options);

/**
 * Get simulation
 *
 * Get a simulation's detail, including status, sim_params, result_summary, error_message, and attempt number. Use this as the polling target while a simulation runs.
 */
export const handleGetSimulationSimulationsSimulationIdGetOptions = (options: Options<HandleGetSimulationSimulationsSimulationIdGetData>) => queryOptions<HandleGetSimulationSimulationsSimulationIdGetResponse, HandleGetSimulationSimulationsSimulationIdGetError, HandleGetSimulationSimulationsSimulationIdGetResponse, ReturnType<typeof handleGetSimulationSimulationsSimulationIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationSimulationsSimulationIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationSimulationsSimulationIdGetQueryKey(options)
});

/**
 * Cancel simulation
 *
 * Cancel a running simulation. Allowed while pending, queued or running; 409 once the run has reached a terminal state, because there is nothing left to cancel. The row is marked cancelled first and the Batch job terminated best-effort after, so a cancel that reaches the database but not AWS leaves an orphaned container rather than a row stuck reporting RUNNING forever. A cancelled run carries no sim_error: it is a cancellation the user chose, not a failure to diagnose. A cancelled run cannot be continued.
 */
export const handleCancelSimulationSimulationsSimulationIdCancelPostMutation = (options?: Partial<Options<HandleCancelSimulationSimulationsSimulationIdCancelPostData>>): UseMutationOptions<HandleCancelSimulationSimulationsSimulationIdCancelPostResponse, HandleCancelSimulationSimulationsSimulationIdCancelPostError, Options<HandleCancelSimulationSimulationsSimulationIdCancelPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCancelSimulationSimulationsSimulationIdCancelPostResponse, HandleCancelSimulationSimulationsSimulationIdCancelPostError, Options<HandleCancelSimulationSimulationsSimulationIdCancelPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCancelSimulationSimulationsSimulationIdCancelPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetSimulationResidualsSimulationsSimulationIdResidualsGetQueryKey = (options: Options<HandleGetSimulationResidualsSimulationsSimulationIdResidualsGetData>) => createQueryKey('handleGetSimulationResidualsSimulationsSimulationIdResidualsGet', options);

/**
 * Get simulation residuals
 *
 * Get a presigned download URL for a simulation's residuals.json — one record per time step, field, and corrector. Readable at any run status. For external_flow, internal_flow, and cht_steady (ENG-1940) the container rewrites this object every few seconds while the solver runs, so a RUNNING sim returns the iterations completed so far; the CalculiX templates never write it. Before the object exists the URL is still issued and the fetch 404s — treat that as 'not yet' and poll again, not as a permanent failure.
 */
export const handleGetSimulationResidualsSimulationsSimulationIdResidualsGetOptions = (options: Options<HandleGetSimulationResidualsSimulationsSimulationIdResidualsGetData>) => queryOptions<HandleGetSimulationResidualsSimulationsSimulationIdResidualsGetResponse, HandleGetSimulationResidualsSimulationsSimulationIdResidualsGetError, HandleGetSimulationResidualsSimulationsSimulationIdResidualsGetResponse, ReturnType<typeof handleGetSimulationResidualsSimulationsSimulationIdResidualsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationResidualsSimulationsSimulationIdResidualsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationResidualsSimulationsSimulationIdResidualsGetQueryKey(options)
});

export const handleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetQueryKey = (options: Options<HandleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetData>) => createQueryKey('handleGetSimulationConvergenceSimulationsSimulationIdConvergenceGet', options);

/**
 * Get simulation convergence
 *
 * Presigned URL for CalculiX convergence_history.json. Structural runs refresh a bounded preview while solving, then publish final evidence even on failure. Rows carry step/increment/attempt/iteration and CCX percentages; not CFD residuals. Available in every simulation status; a missing object returns 404 until the first flush.
 */
export const handleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetOptions = (options: Options<HandleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetData>) => queryOptions<HandleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetResponse, HandleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetError, HandleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetResponse, ReturnType<typeof handleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationConvergenceSimulationsSimulationIdConvergenceGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationConvergenceSimulationsSimulationIdConvergenceGetQueryKey(options)
});

export const handleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetQueryKey = (options: Options<HandleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetData>) => createQueryKey('handleGetSimulationMonitoringSimulationsSimulationIdMonitoringGet', options);

/**
 * Get simulation monitoring
 *
 * Get a presigned download URL for a simulation's monitoring.csv — per-iteration continuity errors and timings. The URL is issued in any status, but what a 404 on the fetch means depends on the template. external_flow, internal_flow, and cht_steady (ENG-1940) refresh the object mid-run: a 404 there means 'not yet' and clears within the first flush interval. Structural CalculiX runs produce a different CSV: step, increment, attempt, iteration, contact count and force/displacement/flux/temperature convergence percentages. Other CalculiX templates do not currently produce this artifact.
 */
export const handleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetOptions = (options: Options<HandleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetData>) => queryOptions<HandleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetResponse, HandleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetError, HandleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetResponse, ReturnType<typeof handleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationMonitoringSimulationsSimulationIdMonitoringGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationMonitoringSimulationsSimulationIdMonitoringGetQueryKey(options)
});

export const handleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetQueryKey = (options: Options<HandleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetData>) => createQueryKey('handleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGet', options);

/**
 * Get simulation interface flux series
 *
 * Get a presigned download URL for a CHT simulation's interface_flux_series.json — per-write-interval interface heat flux (W) for every fluid- and solid-side coupled patch, so the FE can overlay flux against the residual chart. cht_steady only; written once when the run ends. The URL is issued in any status, but a 404 on the fetch means 'not yet' for a RUNNING CHT run and is permanent for non-CHT templates, which never produce it.
 */
export const handleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetOptions = (options: Options<HandleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetData>) => queryOptions<HandleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetResponse, HandleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetError, HandleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetResponse, ReturnType<typeof handleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationInterfaceFluxSeriesSimulationsSimulationIdInterfaceFluxSeriesGetQueryKey(options)
});

export const handleGetSimulationLogsSimulationsSimulationIdLogsGetQueryKey = (options: Options<HandleGetSimulationLogsSimulationsSimulationIdLogsGetData>) => createQueryKey('handleGetSimulationLogsSimulationsSimulationIdLogsGet', options);

/**
 * Get simulation logs
 *
 * Get a presigned download URL for a simulation's full output bundle. This is the same output.tar.gz that download_simulation returns; logs and results ship together. The archive is only written when the run terminates, so this is COMPLETED or FAILED only; 400 while running. To see how a RUNNING sim is going, read get_simulation_residuals or get_simulation_monitoring — those are refreshed mid-run.
 */
export const handleGetSimulationLogsSimulationsSimulationIdLogsGetOptions = (options: Options<HandleGetSimulationLogsSimulationsSimulationIdLogsGetData>) => queryOptions<HandleGetSimulationLogsSimulationsSimulationIdLogsGetResponse, HandleGetSimulationLogsSimulationsSimulationIdLogsGetError, HandleGetSimulationLogsSimulationsSimulationIdLogsGetResponse, ReturnType<typeof handleGetSimulationLogsSimulationsSimulationIdLogsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationLogsSimulationsSimulationIdLogsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationLogsSimulationsSimulationIdLogsGetQueryKey(options)
});

export const handleDownloadSimulationSimulationsSimulationIdDownloadGetQueryKey = (options: Options<HandleDownloadSimulationSimulationsSimulationIdDownloadGetData>) => createQueryKey('handleDownloadSimulationSimulationsSimulationIdDownloadGet', options);

/**
 * Download simulation
 *
 * Get a presigned download URL for a simulation's results bundle (output.tar.gz). Available once the simulation is COMPLETED or FAILED; a failed run still yields logs and partial output. 400 while still running.
 */
export const handleDownloadSimulationSimulationsSimulationIdDownloadGetOptions = (options: Options<HandleDownloadSimulationSimulationsSimulationIdDownloadGetData>) => queryOptions<HandleDownloadSimulationSimulationsSimulationIdDownloadGetResponse, HandleDownloadSimulationSimulationsSimulationIdDownloadGetError, HandleDownloadSimulationSimulationsSimulationIdDownloadGetResponse, ReturnType<typeof handleDownloadSimulationSimulationsSimulationIdDownloadGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleDownloadSimulationSimulationsSimulationIdDownloadGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleDownloadSimulationSimulationsSimulationIdDownloadGetQueryKey(options)
});

export const handleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetQueryKey = (options: Options<HandleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetData>) => createQueryKey('handleDownloadSimulationInputSimulationsSimulationIdDownloadInputGet', options);

/**
 * Download simulation input
 *
 * Get a presigned download URL for a simulation's input case bundle (case.tar.gz). The case is staged before the solver runs, so this works in any run status, unlike download_simulation which needs COMPLETED or FAILED.
 */
export const handleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetOptions = (options: Options<HandleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetData>) => queryOptions<HandleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetResponse, HandleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetError, HandleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetResponse, ReturnType<typeof handleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleDownloadSimulationInputSimulationsSimulationIdDownloadInputGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleDownloadSimulationInputSimulationsSimulationIdDownloadInputGetQueryKey(options)
});

export const handleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetQueryKey = (options: Options<HandleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetData>) => createQueryKey('handleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGet', options);

/**
 * Get visualization URL
 *
 * Get presigned URLs for a completed simulation's visualization payload. CFD returns files under the visualization/ prefix; FEA returns visualization.json plus optional signed frames*.json shards for the scrubber. 400 until COMPLETED.
 */
export const handleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetOptions = (options: Options<HandleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetData>) => queryOptions<HandleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetResponse, HandleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetError, HandleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetResponse, ReturnType<typeof handleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetVisualizationUrlSimulationsSimulationIdVisualizationUrlGetQueryKey(options)
});

export const handleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetQueryKey = (options: Options<HandleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetData>) => createQueryKey('handleGetSimulationThumbnailSimulationsSimulationIdThumbnailGet', options);

/**
 * Get simulation thumbnail
 *
 * Get a freshly signed, short-lived (1 hour) URL for a simulation's preview PNG, as JSON. Load the URL directly; call again for a new one rather than storing it. The VIEWER check runs on every call. 404 when there is no thumbnail — the normal answer for simulations that predate the render, for a render that failed (it is best-effort), and for FEA simulations, which are not rendered yet.
 */
export const handleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetOptions = (options: Options<HandleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetData>) => queryOptions<HandleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetResponse, HandleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetError, HandleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetResponse, ReturnType<typeof handleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationThumbnailSimulationsSimulationIdThumbnailGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationThumbnailSimulationsSimulationIdThumbnailGetQueryKey(options)
});

export const handleGetSimulationSeriesSimulationsSimulationIdSeriesGetQueryKey = (options: Options<HandleGetSimulationSeriesSimulationsSimulationIdSeriesGetData>) => createQueryKey('handleGetSimulationSeriesSimulationsSimulationIdSeriesGet', options);

/**
 * Get simulation series
 *
 * Sample a physical field along a line through a completed simulation's volume and return the (x, y) series — e.g. temperature vs x at fixed y and z. Coordinates are millimetres in CAD space (hotspots.json coords are METRES in the same frame — multiply by 1000 before passing them). Give the line in ONE of two ways: `vary_axis` plus the two other coordinates as x/y/z, which spans the region's own bounds along that axis and plots against that coordinate; or all six of x1,y1,z1,x2,y2,z2, which samples exactly that segment in any orientation and plots against distance from the first point. `x_label` says which you got — read it rather than assuming an axis. The response also carries `bounds_mm`, the sampled region's extent, which is what to choose coordinates from. CHT sims are multi-region and require `region`; single-region CFD sims take none. `field` is one of U, p, T, k, omega, nut (U plots |U|) for CFD/CHT. FEA and thermal sims take displacement, displacement_x/y/z, von_mises, max_principal, min_principal, max_shear, or temperature (K; not T) and sample the nodal result over its persisted tetrahedra; legacy FEA runs without v4 connectivity must be re-run. A field the run did not solve is simply absent — an incompressible case has no T, and a CHT solid carries T only. Sampling reads the solver's own mesh, so values are the cells it computed and `fidelity` is `exact`. A mesh too large for this deployment falls back to the resampled uniform grid built for the 3-D viewer: `fidelity` then reads `interpolated`, and `grid_samples_on_axis` and `voxel_size_mm` appear — compare that pitch against the smallest feature the line crosses before trusting a gradient, since even spacing is coarsest exactly where a solver refines. 400 until COMPLETED, for invalid lines or fields, and for a run whose grid predates the requested field (re-run the study).
 */
export const handleGetSimulationSeriesSimulationsSimulationIdSeriesGetOptions = (options: Options<HandleGetSimulationSeriesSimulationsSimulationIdSeriesGetData>) => queryOptions<HandleGetSimulationSeriesSimulationsSimulationIdSeriesGetResponse, HandleGetSimulationSeriesSimulationsSimulationIdSeriesGetError, HandleGetSimulationSeriesSimulationsSimulationIdSeriesGetResponse, ReturnType<typeof handleGetSimulationSeriesSimulationsSimulationIdSeriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationSeriesSimulationsSimulationIdSeriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationSeriesSimulationsSimulationIdSeriesGetQueryKey(options)
});

export const handleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetQueryKey = (options: Options<HandleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetData>) => createQueryKey('handleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGet', options);

/**
 * Get simulation history catalogue
 *
 * What this run can plot against solver ITERATION, so a caller offers only charts that can actually be drawn. Which series exist is a property of the run, not a fixed list: the template decides which function objects were emitted, and a run predating the solid-side sensors has no solid-region temperature at all. Read from the run's own output bundle, so it works on runs that finished long before this endpoint shipped. Each entry carries the `key` to pass to `/simulations/{id}/series/history`, a unit, how many points it has, and its `cadence` — `iteration` for every solver step, `write_interval` for every writeInterval step, `time` / `frequency` for CalculiX `time_history.json` (ENG-2976). A 1500-point curve and a 15-point one can come off the same CHT run. Two series are derived, because no function object writes a difference: `<region>.pressure_drop` (inlet minus outlet) ends on the summary's `pressure_drop_pa`, `<region>.delta_t` (outlet minus inlet temperature) ends on its `coolant_delta_t_k`, and `<fluid>.energy_closure` (the solids' declared power minus the interface flux into that fluid, from the bundle's own summary) flattens when the heat paths have settled, at zero only if every path is an interface. `<region>.limiter_clamps_velocity` and its two `..._temperature_lower` / `..._temperature_upper` siblings come from the solver log rather than a function object: how many cells a limiter rewrote at each iteration, ending on the count the summary reports. Still climbing at the last iteration means the run was being held together when it stopped. Pressure units follow the solver: true pascals for CHT, kinematic p/rho for the incompressible templates. CHT ONLY today: this reads the per-region `postProcessing/<region>/<object>/<time>/` layout that only the CHT template writes, so a single-region CFD run returns an empty list even when it has function-object output. An empty list is otherwise a real answer: a run predating the function objects, or one that ended before the first write. 400 until COMPLETED.
 */
export const handleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetOptions = (options: Options<HandleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetData>) => queryOptions<HandleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetResponse, HandleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetError, HandleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetResponse, ReturnType<typeof handleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationHistoryCatalogueSimulationsSimulationIdPlottableSeriesGetQueryKey(options)
});

export const handleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetQueryKey = (options: Options<HandleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetData>) => createQueryKey('handleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGet', options);

/**
 * Get simulation history series
 *
 * One quantity against solver ITERATION — e.g. a solid region's max T over 1500 steps. Answers a question residuals cannot. A residual measures how much a field still moves each STEP, so it goes quiet once the steps are small, and says nothing about how much movement is left. Measured on a 300 W CHT run: the `h` residual fell 3,157x and flattened while the hottest solid climbed 85 K and was still gaining 9.5 K per 1000 iterations at the last step. Pass a `series` key from `/plottable-series`; anything else is a 400 that lists what this run has. `fidelity` is `recorded`: the solver wrote these values itself while it ran, so nothing was sampled off a mesh or resampled onto a grid, and the spatial source's resolution and bounds fields are absent rather than zero. `cadence` says how often the quantity was written. 400 until COMPLETED.
 */
export const handleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetOptions = (options: Options<HandleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetData>) => queryOptions<HandleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetResponse, HandleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetError, HandleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetResponse, ReturnType<typeof handleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSimulationHistorySeriesSimulationsSimulationIdSeriesHistoryGetQueryKey(options)
});

/**
 * Confirm fastener proposals
 *
 * Apply only user-confirmed shank/bore proposal IDs from get_fastener_proposals. Adds mesh face tags and contact pairs to one CAD-in draft study with independent FEA bodies. Preserves other settings. Rejects stale revisions and conflicting labels. Does not mesh, solve, or apply preload. Run the study separately after reviewing loads and materials.
 */
export const handleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostMutation = (options?: Partial<Options<HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostData>>): UseMutationOptions<HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostResponse, HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostError, Options<HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostData>> => {
    const mutationOptions: UseMutationOptions<HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostResponse, HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostError, Options<HandleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleConfirmFastenerProposalsStudiesStudyIdConfirmFastenerProposalsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm mesh bonded proposals
 *
 * Add selected mesh-measured bonded ties to a draft structural or thermal study of that mesh, or a CAD-in study of its geometry. Each names the contact's two Faying_ sets. Refuses a stale revision, a dependent side tied twice, a side in a contact pair, and more than 64 ties. Does not run the study.
 */
export const handleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostMutation = (options?: Partial<Options<HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostData>>): UseMutationOptions<HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostResponse, HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostError, Options<HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostData>> => {
    const mutationOptions: UseMutationOptions<HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostResponse, HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostError, Options<HandleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleConfirmMeshBondedProposalsStudiesStudyIdConfirmMeshBondedProposalsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm bonded proposals
 *
 * Add only user-confirmed bonded face pairs to a CAD-in draft study with independent FEA bodies. Reject stale diagnosis, reused dependent faces, conflicting contact, and distant or non-opposing pairs. Does not mesh or run the study.
 */
export const handleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostMutation = (options?: Partial<Options<HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostData>>): UseMutationOptions<HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostResponse, HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostError, Options<HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostData>> => {
    const mutationOptions: UseMutationOptions<HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostResponse, HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostError, Options<HandleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleConfirmBondedProposalsStudiesStudyIdConfirmBondedProposalsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetQueryKey = (options: Options<GetAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetData>) => createQueryKey('getAuthoringSchemaStudiesAuthoringSchemaSchemaNameGet', options);

/**
 * Get authoring schema
 *
 * Full input JSON Schema for FEA setup, boundary conditions and face assignment. Includes nested properties, units, defaults and constraints. Read before create_mesh/create_study/update_study; schema availability does not imply geometry supports every condition.
 */
export const getAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetOptions = (options: Options<GetAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetData>) => queryOptions<GetAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetResponse, GetAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetError, GetAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetResponse, ReturnType<typeof getAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAuthoringSchemaStudiesAuthoringSchemaSchemaNameGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAuthoringSchemaStudiesAuthoringSchemaSchemaNameGetQueryKey(options)
});

export const handleGetStudyDesignIntentStudiesStudyIdDesignIntentGetQueryKey = (options: Options<HandleGetStudyDesignIntentStudiesStudyIdDesignIntentGetData>) => createQueryKey('handleGetStudyDesignIntentStudiesStudyIdDesignIntentGet', options);

/**
 * Get study design intent
 *
 * Read the engineer's design intent for every lineage root the study's inputs resolve to (deduplicated; an input mesh made without a geometry has none): each root's name, its text (null when none is written) and `can_edit`, whether the caller may replace it. Study view access is enough to read them; 404 otherwise.
 */
export const handleGetStudyDesignIntentStudiesStudyIdDesignIntentGetOptions = (options: Options<HandleGetStudyDesignIntentStudiesStudyIdDesignIntentGetData>) => queryOptions<HandleGetStudyDesignIntentStudiesStudyIdDesignIntentGetResponse, HandleGetStudyDesignIntentStudiesStudyIdDesignIntentGetError, HandleGetStudyDesignIntentStudiesStudyIdDesignIntentGetResponse, ReturnType<typeof handleGetStudyDesignIntentStudiesStudyIdDesignIntentGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetStudyDesignIntentStudiesStudyIdDesignIntentGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetStudyDesignIntentStudiesStudyIdDesignIntentGetQueryKey(options)
});

/**
 * Delete study
 *
 * Soft-delete a study so it disappears from listings (owner only; returns 204). A running study's workflow execution is left untouched.
 */
export const handleDeleteStudyStudiesStudyIdDeleteMutation = (options?: Partial<Options<HandleDeleteStudyStudiesStudyIdDeleteData>>): UseMutationOptions<HandleDeleteStudyStudiesStudyIdDeleteResponse, HandleDeleteStudyStudiesStudyIdDeleteError, Options<HandleDeleteStudyStudiesStudyIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleDeleteStudyStudiesStudyIdDeleteResponse, HandleDeleteStudyStudiesStudyIdDeleteError, Options<HandleDeleteStudyStudiesStudyIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDeleteStudyStudiesStudyIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetStudyStudiesStudyIdGetQueryKey = (options: Options<HandleGetStudyStudiesStudyIdGetData>) => createQueryKey('handleGetStudyStudiesStudyIdGet', options);

/**
 * Get study
 *
 * Get full detail for one study, including its config, status, point counters, and timestamps; poll this while a study is running.
 */
export const handleGetStudyStudiesStudyIdGetOptions = (options: Options<HandleGetStudyStudiesStudyIdGetData>) => queryOptions<HandleGetStudyStudiesStudyIdGetResponse, HandleGetStudyStudiesStudyIdGetError, HandleGetStudyStudiesStudyIdGetResponse, ReturnType<typeof handleGetStudyStudiesStudyIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetStudyStudiesStudyIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetStudyStudiesStudyIdGetQueryKey(options)
});

/**
 * Update study
 *
 * Update a study's fields. The name is editable in any status, config only in draft (400 otherwise).
 */
export const handleUpdateStudyStudiesStudyIdPatchMutation = (options?: Partial<Options<HandleUpdateStudyStudiesStudyIdPatchData>>): UseMutationOptions<HandleUpdateStudyStudiesStudyIdPatchResponse, HandleUpdateStudyStudiesStudyIdPatchError, Options<HandleUpdateStudyStudiesStudyIdPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateStudyStudiesStudyIdPatchResponse, HandleUpdateStudyStudiesStudyIdPatchError, Options<HandleUpdateStudyStudiesStudyIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateStudyStudiesStudyIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add manual design points
 *
 * Append one or more manual design points to a draft study's config. Existing entries with the same id are replaced (idempotent); everything else is appended. Draft-only: rejects with 400 once the study has been run. Enforces the 100-entry cap on the merged list. Membership + override-key validity is enforced later at run_study.
 */
export const handleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostMutation = (options?: Partial<Options<HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostData>>): UseMutationOptions<HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostResponse, HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostError, Options<HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostData>> => {
    const mutationOptions: UseMutationOptions<HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostResponse, HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostError, Options<HandleAddManualDesignPointsStudiesStudyIdDesignPointsManualPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleAddManualDesignPointsStudiesStudyIdDesignPointsManualPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete manual design point
 *
 * Remove one manual design point from a draft study's config by its id. The inverse of the additive route, and the safe way to drop a single entry: the general config PATCH replaces the whole config, so a caller that has not read the study first can wipe solver settings and inputs on the way past. Draft-only: rejects with 400 once the study has been run. 404 when no entry carries that id.
 */
export const handleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteMutation = (options?: Partial<Options<HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteData>>): UseMutationOptions<HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteResponse, HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteError, Options<HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteResponse, HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteError, Options<HandleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDeleteManualDesignPointStudiesStudyIdDesignPointsManualManualIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update study visibility
 *
 * Set a study's visibility to private, organization, or public (owner only). Returns the updated study detail.
 */
export const handleUpdateVisibilityStudiesStudyIdVisibilityPatchMutation = (options?: Partial<Options<HandleUpdateVisibilityStudiesStudyIdVisibilityPatchData>>): UseMutationOptions<HandleUpdateVisibilityStudiesStudyIdVisibilityPatchResponse, HandleUpdateVisibilityStudiesStudyIdVisibilityPatchError, Options<HandleUpdateVisibilityStudiesStudyIdVisibilityPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateVisibilityStudiesStudyIdVisibilityPatchResponse, HandleUpdateVisibilityStudiesStudyIdVisibilityPatchError, Options<HandleUpdateVisibilityStudiesStudyIdVisibilityPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateVisibilityStudiesStudyIdVisibilityPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Run study
 *
 * Validate a draft study and start its workflow execution; the study moves from draft to running. Mesh-in studies get their simulation_ids via list_design_points shortly after. CAD-in studies mesh first and may pause for review: check get_study and resume with resume_boundary_conditions, complete_meshing, or decide_study.
 */
export const handleRunStudyStudiesStudyIdRunPostMutation = (options?: Partial<Options<HandleRunStudyStudiesStudyIdRunPostData>>): UseMutationOptions<HandleRunStudyStudiesStudyIdRunPostResponse, HandleRunStudyStudiesStudyIdRunPostError, Options<HandleRunStudyStudiesStudyIdRunPostData>> => {
    const mutationOptions: UseMutationOptions<HandleRunStudyStudiesStudyIdRunPostResponse, HandleRunStudyStudiesStudyIdRunPostError, Options<HandleRunStudyStudiesStudyIdRunPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRunStudyStudiesStudyIdRunPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Notify when study finishes
 *
 * Ask to be told once, when this study finishes (completed, completed with issues, failed or cancelled). Chat needs the chat_session_id to deliver to and the message arrives in that session; email always goes to the caller's own account email and takes no address. Viewer access is enough. If the study has already finished nothing is written and already_finished is true. Asking twice for the same session is one notification, not two.
 */
export const handleNotifyStudyStudiesStudyIdNotifyPostMutation = (options?: Partial<Options<HandleNotifyStudyStudiesStudyIdNotifyPostData>>): UseMutationOptions<HandleNotifyStudyStudiesStudyIdNotifyPostResponse, HandleNotifyStudyStudiesStudyIdNotifyPostError, Options<HandleNotifyStudyStudiesStudyIdNotifyPostData>> => {
    const mutationOptions: UseMutationOptions<HandleNotifyStudyStudiesStudyIdNotifyPostResponse, HandleNotifyStudyStudiesStudyIdNotifyPostError, Options<HandleNotifyStudyStudiesStudyIdNotifyPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleNotifyStudyStudiesStudyIdNotifyPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListReportEditsStudiesStudyIdReportEditsGetQueryKey = (options: Options<HandleListReportEditsStudiesStudyIdReportEditsGetData>) => createQueryKey('handleListReportEditsStudiesStudyIdReportEditsGet', options);

/**
 * List study report edits
 *
 * List the study report's prose edit history, newest first, paginated. Each row carries the prior + new value so the editor can see what changed and re-PATCH an earlier value back. Editor role required.
 */
export const handleListReportEditsStudiesStudyIdReportEditsGetOptions = (options: Options<HandleListReportEditsStudiesStudyIdReportEditsGetData>) => queryOptions<HandleListReportEditsStudiesStudyIdReportEditsGetResponse, HandleListReportEditsStudiesStudyIdReportEditsGetError, HandleListReportEditsStudiesStudyIdReportEditsGetResponse, ReturnType<typeof handleListReportEditsStudiesStudyIdReportEditsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListReportEditsStudiesStudyIdReportEditsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListReportEditsStudiesStudyIdReportEditsGetQueryKey(options)
});

export const handleListReportEditsStudiesStudyIdReportEditsGetInfiniteQueryKey = (options: Options<HandleListReportEditsStudiesStudyIdReportEditsGetData>): QueryKey<Options<HandleListReportEditsStudiesStudyIdReportEditsGetData>> => createQueryKey('handleListReportEditsStudiesStudyIdReportEditsGet', options, true);

/**
 * List study report edits
 *
 * List the study report's prose edit history, newest first, paginated. Each row carries the prior + new value so the editor can see what changed and re-PATCH an earlier value back. Editor role required.
 */
export const handleListReportEditsStudiesStudyIdReportEditsGetInfiniteOptions = (options: Options<HandleListReportEditsStudiesStudyIdReportEditsGetData>) => infiniteQueryOptions<HandleListReportEditsStudiesStudyIdReportEditsGetResponse, HandleListReportEditsStudiesStudyIdReportEditsGetError, InfiniteData<HandleListReportEditsStudiesStudyIdReportEditsGetResponse>, QueryKey<Options<HandleListReportEditsStudiesStudyIdReportEditsGetData>>, string | null | Pick<QueryKey<Options<HandleListReportEditsStudiesStudyIdReportEditsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<HandleListReportEditsStudiesStudyIdReportEditsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await handleListReportEditsStudiesStudyIdReportEditsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListReportEditsStudiesStudyIdReportEditsGetInfiniteQueryKey(options)
});

export const handleListPointsStudiesStudyIdPointsGetQueryKey = (options: Options<HandleListPointsStudiesStudyIdPointsGetData>) => createQueryKey('handleListPointsStudiesStudyIdPointsGet', options);

/**
 * List design points
 *
 * List a study's design points, newest first, paginated. Each point carries its inputs, status, simulation_id, result_summary, error_message, and full attempt history.
 */
export const handleListPointsStudiesStudyIdPointsGetOptions = (options: Options<HandleListPointsStudiesStudyIdPointsGetData>) => queryOptions<HandleListPointsStudiesStudyIdPointsGetResponse, HandleListPointsStudiesStudyIdPointsGetError, HandleListPointsStudiesStudyIdPointsGetResponse, ReturnType<typeof handleListPointsStudiesStudyIdPointsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListPointsStudiesStudyIdPointsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListPointsStudiesStudyIdPointsGetQueryKey(options)
});

export const handleListPointsStudiesStudyIdPointsGetInfiniteQueryKey = (options: Options<HandleListPointsStudiesStudyIdPointsGetData>): QueryKey<Options<HandleListPointsStudiesStudyIdPointsGetData>> => createQueryKey('handleListPointsStudiesStudyIdPointsGet', options, true);

/**
 * List design points
 *
 * List a study's design points, newest first, paginated. Each point carries its inputs, status, simulation_id, result_summary, error_message, and full attempt history.
 */
export const handleListPointsStudiesStudyIdPointsGetInfiniteOptions = (options: Options<HandleListPointsStudiesStudyIdPointsGetData>) => infiniteQueryOptions<HandleListPointsStudiesStudyIdPointsGetResponse, HandleListPointsStudiesStudyIdPointsGetError, InfiniteData<HandleListPointsStudiesStudyIdPointsGetResponse>, QueryKey<Options<HandleListPointsStudiesStudyIdPointsGetData>>, string | null | Pick<QueryKey<Options<HandleListPointsStudiesStudyIdPointsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<HandleListPointsStudiesStudyIdPointsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await handleListPointsStudiesStudyIdPointsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListPointsStudiesStudyIdPointsGetInfiniteQueryKey(options)
});

/**
 * Submit design point
 *
 * Submit one new design point to an existing study and dispatch its simulation immediately. Returns the design point with its design point id and new simulation_id. Works on running, completed, or failed studies (a terminal study reopens to running). For CFD (external_flow / internal_flow), inputs uses flat axis keys (nu, inlet.velocity, outlet.pressure). structural_static takes axes named after the study's OWN entries — contact_pairs.<name>.friction_coefficient, boundary_conditions.<face_id>.vector_n.<0|1|2>, bolt_shrink_preloads.<name>.force_n — so the allowed set differs per study; an unknown axis is refused with that study's real list, and only numeric paths are axes (swap a material through overrides). cht_steady, modal_frequency and thermal_conduction take no sweep axes: submit with empty inputs to re-run the stored config, optionally against a different mesh_id in the study's input set. 409 for MOBO or GCI studies, paused states, and drafts (run_study first). Not idempotent: if the response is lost, check list_design_points before retrying.
 */
export const handleSubmitDesignPointStudiesStudyIdPointsPostMutation = (options?: Partial<Options<HandleSubmitDesignPointStudiesStudyIdPointsPostData>>): UseMutationOptions<HandleSubmitDesignPointStudiesStudyIdPointsPostResponse, HandleSubmitDesignPointStudiesStudyIdPointsPostError, Options<HandleSubmitDesignPointStudiesStudyIdPointsPostData>> => {
    const mutationOptions: UseMutationOptions<HandleSubmitDesignPointStudiesStudyIdPointsPostResponse, HandleSubmitDesignPointStudiesStudyIdPointsPostError, Options<HandleSubmitDesignPointStudiesStudyIdPointsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleSubmitDesignPointStudiesStudyIdPointsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch submit design points
 *
 * Append up to 50 new design points to an existing study in one call and dispatch each simulation immediately. Each entry is the same shape submit_design_point takes solo (inputs + optional mesh_id + optional overrides). Same admitted study statuses as the single-DP endpoint (running / completed / completed_with_issues / failed; terminal studies reopen to running). Not atomic across the batch: on a Batch failure at index K, points 0..K-1 stay committed and K+1..N are never attempted — re-query with list_design_points to reconcile. 409 for MOBO / GCI studies, paused states, and drafts.
 */
export const handleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostMutation = (options?: Partial<Options<HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostData>>): UseMutationOptions<HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostResponse, HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostError, Options<HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostData>> => {
    const mutationOptions: UseMutationOptions<HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostResponse, HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostError, Options<HandleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleBatchSubmitDesignPointsStudiesStudyIdPointsBatchPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetDesignPointStudiesStudyIdPointsDpIdGetQueryKey = (options: Options<HandleGetDesignPointStudiesStudyIdPointsDpIdGetData>) => createQueryKey('handleGetDesignPointStudiesStudyIdPointsDpIdGet', options);

/**
 * Get design point
 *
 * Get one design point's derived status, inputs, result_summary, error_message, and full attempt history (newest first). The polling target after submit_design_point or retry_design_point_ai.
 */
export const handleGetDesignPointStudiesStudyIdPointsDpIdGetOptions = (options: Options<HandleGetDesignPointStudiesStudyIdPointsDpIdGetData>) => queryOptions<HandleGetDesignPointStudiesStudyIdPointsDpIdGetResponse, HandleGetDesignPointStudiesStudyIdPointsDpIdGetError, HandleGetDesignPointStudiesStudyIdPointsDpIdGetResponse, ReturnType<typeof handleGetDesignPointStudiesStudyIdPointsDpIdGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetDesignPointStudiesStudyIdPointsDpIdGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetDesignPointStudiesStudyIdPointsDpIdGetQueryKey(options)
});

/**
 * Update design point
 *
 * Set chart-swatch identity (label / color) and soft-skip a design point (ENG-1375). PATCH semantics: omitted fields preserve the column, explicit null clears, ``skipped=false`` un-skips. Editor role required; allowed in any study status.
 */
export const handleUpdateDesignPointStudiesStudyIdPointsDpIdPatchMutation = (options?: Partial<Options<HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchData>>): UseMutationOptions<HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchResponse, HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchError, Options<HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchResponse, HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchError, Options<HandleUpdateDesignPointStudiesStudyIdPointsDpIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateDesignPointStudiesStudyIdPointsDpIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove reviewer verification
 *
 * Append a revocation for the current attempt without deleting the audit trail.
 */
export const handleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteMutation = (options?: Partial<Options<HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteData>>): UseMutationOptions<HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteResponse, HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteError, Options<HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteResponse, HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteError, Options<HandleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRevokeVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Confirm reviewer verification
 *
 * Acknowledge every unresolved automated check for the current completed attempt. Does not change solver verification.
 */
export const handleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostMutation = (options?: Partial<Options<HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostData>>): UseMutationOptions<HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostResponse, HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostError, Options<HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostData>> => {
    const mutationOptions: UseMutationOptions<HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostResponse, HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostError, Options<HandleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleConfirmVerificationReviewStudiesStudyIdPointsDpIdVerificationReviewPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry design point with AI
 *
 * Retry a failed design point: an AI agent reviews the failure, amends the sim params, and dispatches a new attempt. The response carries the design point with its new simulation_id. 409 if the point is not retryable or the agent declines; 402 if the workspace or user has no access to the agent. Optionally pass expected_simulation_id to reject a superseded source run instead of retrying the latest attempt.
 */
export const handleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostMutation = (options?: Partial<Options<HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostData>>): UseMutationOptions<HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostResponse, HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostError, Options<HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostData>> => {
    const mutationOptions: UseMutationOptions<HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostResponse, HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostError, Options<HandleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRetryDesignPointAiStudiesStudyIdPointsDpIdRetryAiPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Retry design point unchanged
 *
 * Retry a failed design point with its settings unchanged, without asking the AI agent — for when the agent declined or could not answer and you want the run again anyway. The response carries the design point with its new simulation_id. 409 if the point is not retryable. Optionally pass expected_simulation_id to reject a superseded source run instead of retrying the latest attempt.
 */
export const handleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostMutation = (options?: Partial<Options<HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostData>>): UseMutationOptions<HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostResponse, HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostError, Options<HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostData>> => {
    const mutationOptions: UseMutationOptions<HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostResponse, HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostError, Options<HandleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRetryDesignPointUnchangedStudiesStudyIdPointsDpIdRetryPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add study input
 *
 * Append one geometry_id or mesh_id to a study's inputs (ENG-1516). Surgical helper — avoids the full update_study(config=...) round-trip for the common op. Exactly one of geometry_id / mesh_id must be set; idempotent on repeat. Allowed on any submittable status — draft, running, completed or failed — because re-running a finished study against a new mesh is the retry loop, and this is what submit_design_point means when it says to add the mesh here first.
 */
export const handleAddStudyInputStudiesStudyIdInputsPostMutation = (options?: Partial<Options<HandleAddStudyInputStudiesStudyIdInputsPostData>>): UseMutationOptions<HandleAddStudyInputStudiesStudyIdInputsPostResponse, HandleAddStudyInputStudiesStudyIdInputsPostError, Options<HandleAddStudyInputStudiesStudyIdInputsPostData>> => {
    const mutationOptions: UseMutationOptions<HandleAddStudyInputStudiesStudyIdInputsPostResponse, HandleAddStudyInputStudiesStudyIdInputsPostError, Options<HandleAddStudyInputStudiesStudyIdInputsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleAddStudyInputStudiesStudyIdInputsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mutate design point
 *
 * Apply engine overrides to one design point + dispatch a new sim attempt straight to Batch (ENG-1516). Only external_flow / internal_flow / structural_static are accepted here — the list is generated from the route's own gate, so it cannot drift from what the server does (ENG-2968). external_flow / internal_flow use the CFD Tier-1 allow-list (ENG-1435 — rho, flow_type, overrides.*, force_coeffs.*). structural_static also admits (ENG-2306) per-instance numeric paths minted from the study's own entries — contact_pairs.<name>.friction_coefficient, boundary_conditions.<face_id>.vector_n.<0|1|2>, bolt_shrink_preloads.<name>.force_n — plus optional wholesale boundary_conditions replacement (ENG-2311). Every other template is refused with a 409: to change a stopped run's limits use continue_design_point, and to re-run a point with its stored config use submit_design_point with empty inputs. Editor role required.
 */
export const handleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostMutation = (options?: Partial<Options<HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostData>>): UseMutationOptions<HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostResponse, HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostError, Options<HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostData>> => {
    const mutationOptions: UseMutationOptions<HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostResponse, HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostError, Options<HandleMutateDesignPointStudiesStudyIdPointsDpIdMutatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleMutateDesignPointStudiesStudyIdPointsDpIdMutatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Continue design point
 *
 * Continue a design point from its last checkpoint. Three kinds of run qualify: one that is stopped (status `stopped`, previously called `paused`) — an OpenFOAM run that stopped at its time limit (ENG-2864), or at its iteration limit on a row from before ENG-3042 or with a divergence signal; a `completed` steady run that ended at its iteration limit without diverging, which counts as converged (ENG-3042) and can be carried on for more iterations; and one that FAILED without the solver breaking: the infrastructure killed it (a Spot reclaim, an S3 stall, an OOM kill or the wall-clock cap, ENG-2970), or the solve ended cleanly and reading its results failed (`postprocess_failed`, ENG-3029). A run the solver itself failed is NOT continuable, because its last checkpoint may hold the state that broke it. Read `continuable` on the simulation detail rather than inferring either case from the status. Dispatches a new simulation linked to the previous one (`continues_simulation_id`), with the same attempt number and that run's settings plus the optional new `end_time` (steady templates; must exceed the checkpoint, and is required when the run reached its end_time — read `continue_needs_new_end_time`) and `max_run_time_s`. 409 when the current run is not continuable. Editor role required.
 */
export const handleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostMutation = (options?: Partial<Options<HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostData>>): UseMutationOptions<HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostResponse, HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostError, Options<HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostData>> => {
    const mutationOptions: UseMutationOptions<HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostResponse, HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostError, Options<HandleContinueDesignPointStudiesStudyIdPointsDpIdContinuePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleContinueDesignPointStudiesStudyIdPointsDpIdContinuePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Batch update design points
 *
 * Apply the same label / color / skipped to a set of design points in one transaction (ENG-1516). Max 50 dp_ids per call; any id from a different study 404s the whole batch. Editor role required; allowed in any study status.
 */
export const handleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostMutation = (options?: Partial<Options<HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostData>>): UseMutationOptions<HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostResponse, HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostError, Options<HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostData>> => {
    const mutationOptions: UseMutationOptions<HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostResponse, HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostError, Options<HandleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleBatchUpdateDesignPointsStudiesStudyIdPointsBatchUpdatePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clone design points
 *
 * Clone design points from one or more source studies into this destination study (ENG-1516). Preserves inputs / sim_params / label / color; drops simulation_id / results and dispatches fresh sims on the dest study's mesh. Templates must match; max 50 sources. Editor on dest, viewer on each source.
 */
export const handleCloneDesignPointsStudiesStudyIdPointsClonePostMutation = (options?: Partial<Options<HandleCloneDesignPointsStudiesStudyIdPointsClonePostData>>): UseMutationOptions<HandleCloneDesignPointsStudiesStudyIdPointsClonePostResponse, HandleCloneDesignPointsStudiesStudyIdPointsClonePostError, Options<HandleCloneDesignPointsStudiesStudyIdPointsClonePostData>> => {
    const mutationOptions: UseMutationOptions<HandleCloneDesignPointsStudiesStudyIdPointsClonePostResponse, HandleCloneDesignPointsStudiesStudyIdPointsClonePostError, Options<HandleCloneDesignPointsStudiesStudyIdPointsClonePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCloneDesignPointsStudiesStudyIdPointsClonePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update auto retry
 *
 * Enable or disable the study's automatic AI retry of failed simulations and optionally set max_attempts. Allowed in any study status; returns the updated study detail.
 */
export const handleUpdateAutoRetryStudiesStudyIdAutoRetryPatchMutation = (options?: Partial<Options<HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchData>>): UseMutationOptions<HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchResponse, HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchError, Options<HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchResponse, HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchError, Options<HandleUpdateAutoRetryStudiesStudyIdAutoRetryPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateAutoRetryStudiesStudyIdAutoRetryPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Decide study
 *
 * Resolve a paused MOBO optimization iteration. Decision 'continue' creates simulations for the proposed design points and resumes the workflow; 'stop' cancels the proposals and finalizes the study as completed or failed.
 */
export const handleDecideStudyStudiesStudyIdDecidePostMutation = (options?: Partial<Options<HandleDecideStudyStudiesStudyIdDecidePostData>>): UseMutationOptions<HandleDecideStudyStudiesStudyIdDecidePostResponse, HandleDecideStudyStudiesStudyIdDecidePostError, Options<HandleDecideStudyStudiesStudyIdDecidePostData>> => {
    const mutationOptions: UseMutationOptions<HandleDecideStudyStudiesStudyIdDecidePostResponse, HandleDecideStudyStudiesStudyIdDecidePostError, Options<HandleDecideStudyStudiesStudyIdDecidePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDecideStudyStudiesStudyIdDecidePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cancel study
 *
 * Cancel a study that is running or paused at a HITL gate (awaiting_mobo_review, awaiting_user_meshing, awaiting_bc_review) or still preprocessing. Marks the study and its non-terminal design points / in-flight simulations cancelled, then best-effort SendTaskFailure on any held Step Functions token, StopExecution on the Study SFN, and Batch terminate_job for active sims. 409 when the study is already terminal or still a draft — there is nothing left to cancel. Late sim completions after cancel are discarded (cascade treats cancelled studies as sticky).
 */
export const handleCancelStudyStudiesStudyIdCancelPostMutation = (options?: Partial<Options<HandleCancelStudyStudiesStudyIdCancelPostData>>): UseMutationOptions<HandleCancelStudyStudiesStudyIdCancelPostResponse, HandleCancelStudyStudiesStudyIdCancelPostError, Options<HandleCancelStudyStudiesStudyIdCancelPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCancelStudyStudiesStudyIdCancelPostResponse, HandleCancelStudyStudiesStudyIdCancelPostError, Options<HandleCancelStudyStudiesStudyIdCancelPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCancelStudyStudiesStudyIdCancelPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume boundary conditions
 *
 * Resume a study paused for boundary condition review: persists the submitted boundary conditions and signals the workflow to continue. 409 if the study is not awaiting review; 400 if a patch does not exist on the meshes, or if an internal-flow set cannot drive a flow (no inflow, or no outlet).
 */
export const handleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostMutation = (options?: Partial<Options<HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostData>>): UseMutationOptions<HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostResponse, HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostError, Options<HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostData>> => {
    const mutationOptions: UseMutationOptions<HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostResponse, HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostError, Options<HandleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleResumeBoundaryConditionsStudiesStudyIdResumeBoundaryConditionsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set case card
 *
 * Replace-all write of the study's case card (ENG-1688 / ENG-1631). Editor+; any status. The card is required for BC-review resume — an incomplete card causes that endpoint to 409 with a typed refusal.
 */
export const handleSetCaseCardStudiesStudyIdCaseCardPutMutation = (options?: Partial<Options<HandleSetCaseCardStudiesStudyIdCaseCardPutData>>): UseMutationOptions<HandleSetCaseCardStudiesStudyIdCaseCardPutResponse, HandleSetCaseCardStudiesStudyIdCaseCardPutError, Options<HandleSetCaseCardStudiesStudyIdCaseCardPutData>> => {
    const mutationOptions: UseMutationOptions<HandleSetCaseCardStudiesStudyIdCaseCardPutResponse, HandleSetCaseCardStudiesStudyIdCaseCardPutError, Options<HandleSetCaseCardStudiesStudyIdCaseCardPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleSetCaseCardStudiesStudyIdCaseCardPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Complete meshing
 *
 * Resume a study paused for user-driven meshing: creates a pending simulation for each design point with an uploaded mesh and signals the workflow to run them. 409 unless every design point has finished face extraction.
 */
export const handleCompleteMeshingStudiesStudyIdCompleteMeshingPostMutation = (options?: Partial<Options<HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostData>>): UseMutationOptions<HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostResponse, HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostError, Options<HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostResponse, HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostError, Options<HandleCompleteMeshingStudiesStudyIdCompleteMeshingPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCompleteMeshingStudiesStudyIdCompleteMeshingPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetSharingStudiesStudyIdSharingGetQueryKey = (options: Options<HandleGetSharingStudiesStudyIdSharingGetData>) => createQueryKey('handleGetSharingStudiesStudyIdSharingGet', options);

/**
 * Get sharing
 *
 * Get a study's sharing settings: visibility, link role, owner email, and the per-person grants (owner only).
 */
export const handleGetSharingStudiesStudyIdSharingGetOptions = (options: Options<HandleGetSharingStudiesStudyIdSharingGetData>) => queryOptions<HandleGetSharingStudiesStudyIdSharingGetResponse, HandleGetSharingStudiesStudyIdSharingGetError, HandleGetSharingStudiesStudyIdSharingGetResponse, ReturnType<typeof handleGetSharingStudiesStudyIdSharingGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSharingStudiesStudyIdSharingGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSharingStudiesStudyIdSharingGetQueryKey(options)
});

/**
 * Update sharing
 *
 * Set a study's visibility scope and the role its share link grants (owner only). Returns the updated sharing settings.
 */
export const handleUpdateSharingStudiesStudyIdSharingPutMutation = (options?: Partial<Options<HandleUpdateSharingStudiesStudyIdSharingPutData>>): UseMutationOptions<HandleUpdateSharingStudiesStudyIdSharingPutResponse, HandleUpdateSharingStudiesStudyIdSharingPutError, Options<HandleUpdateSharingStudiesStudyIdSharingPutData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateSharingStudiesStudyIdSharingPutResponse, HandleUpdateSharingStudiesStudyIdSharingPutError, Options<HandleUpdateSharingStudiesStudyIdSharingPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateSharingStudiesStudyIdSharingPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create invite
 *
 * Invite a person by email to a study with a viewer, commenter, or editor role, creating or updating the grant (owner only). Sends a best-effort invite email and reports whether it was sent.
 */
export const handleCreateInviteStudiesStudyIdSharingInvitesPostMutation = (options?: Partial<Options<HandleCreateInviteStudiesStudyIdSharingInvitesPostData>>): UseMutationOptions<HandleCreateInviteStudiesStudyIdSharingInvitesPostResponse, HandleCreateInviteStudiesStudyIdSharingInvitesPostError, Options<HandleCreateInviteStudiesStudyIdSharingInvitesPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCreateInviteStudiesStudyIdSharingInvitesPostResponse, HandleCreateInviteStudiesStudyIdSharingInvitesPostError, Options<HandleCreateInviteStudiesStudyIdSharingInvitesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCreateInviteStudiesStudyIdSharingInvitesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete invite
 *
 * Remove a person's share grant from a study (owner only; returns 204). 404 if no grant exists for that email.
 */
export const handleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteMutation = (options?: Partial<Options<HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteData>>): UseMutationOptions<HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteResponse, HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteError, Options<HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteResponse, HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteError, Options<HandleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDeleteInviteStudiesStudyIdSharingInvitesInviteEmailDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update invite
 *
 * Change the role of an existing per-person share grant on a study (owner only). 404 if no grant exists for that email.
 */
export const handleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchMutation = (options?: Partial<Options<HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchData>>): UseMutationOptions<HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchResponse, HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchError, Options<HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchResponse, HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchError, Options<HandleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateInviteStudiesStudyIdSharingInvitesInviteEmailPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetQueryKey = (options: Options<HandleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetData>) => createQueryKey('handleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGet', options);

/**
 * Get hand calc graph
 *
 * This design point's hand calculation: the assembly graph for its current completed or failed simulation — parts, boundary lines, conservation sums and closure gaps — with the saved record replayed over it. The first open of a point drafts that record with one advisor call and saves it before answering; every later open spends nothing. Drafting needs an editor in the same organization; a viewer reads `…/hand-calc/record`. No request body.
 */
export const handleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetOptions = (options: Options<HandleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetData>) => queryOptions<HandleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetResponse, HandleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetError, HandleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetResponse, ReturnType<typeof handleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleHandCalcGraphStudiesStudyIdPointsDpIdHandCalcGetQueryKey(options)
});

/**
 * Save hand calc values
 *
 * Edit this design point's hand calculation. Each of `attach`, `reparent` and `values` that the body carries replaces the record's list of that name; one it leaves out is kept. The edit is saved, then rebuilt and re-solved over what was saved. Editor role, same organization, no advisor call. 409 on a stale `attempt_id`; 422 when the edited record does not check out, and nothing is written.
 */
export const handleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchMutation = (options?: Partial<Options<HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchData>>): UseMutationOptions<HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchResponse, HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchError, Options<HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchResponse, HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchError, Options<HandleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleHandCalcEditStudiesStudyIdPointsDpIdHandCalcPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetQueryKey = (options: Options<HandleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetData>) => createQueryKey('handleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGet', options);

/**
 * Get hand calc record
 *
 * Read this design point's saved hand calculation without drafting one: the assembly graph for its current completed or failed simulation — parts, boundary lines, conservation sums and closure gaps — with the saved record replayed over it and its cards solved. `record` is null when the point has none yet. Never calls the advisor and writes nothing. Readable by any viewer of the study, an anonymous public-link recipient included.
 */
export const handleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetOptions = (options: Options<HandleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetData>) => queryOptions<HandleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetResponse, HandleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetError, HandleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetResponse, ReturnType<typeof handleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetHandCalcRecordStudiesStudyIdPointsDpIdHandCalcRecordGetQueryKey(options)
});

/**
 * Generate hand calc
 *
 * Generate this design point's saved hand calculation when one does not exist, or replay the existing record without another advisor call. Idempotent: never replaces user edits. Requires editor access in the same organization and a completed or failed simulation. No request body.
 */
export const handleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostMutation = (options?: Partial<Options<HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostData>>): UseMutationOptions<HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostResponse, HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostError, Options<HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostData>> => {
    const mutationOptions: UseMutationOptions<HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostResponse, HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostError, Options<HandleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleGenerateHandCalcStudiesStudyIdPointsDpIdHandCalcGeneratePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Regenerate hand calc
 *
 * Draft this design point's hand calculation again and store it in place of the saved one, the engineer's own edits included. One advisor call, over the same graph the first open drafted from. Editor role, same organization. 409 on a stale `attempt_id`; 422 when no graph can be built or nothing the advisor drafted applies; 503 when the advisor does not answer. The saved record is left untouched unless a new one survives the checks.
 */
export const handleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostMutation = (options?: Partial<Options<HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostData>>): UseMutationOptions<HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostResponse, HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostError, Options<HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostData>> => {
    const mutationOptions: UseMutationOptions<HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostResponse, HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostError, Options<HandleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleHandCalcRegenerateStudiesStudyIdPointsDpIdHandCalcRegeneratePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetQueryKey = (options: Options<HandleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetData>) => createQueryKey('handleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGet', options);

/**
 * Get hand calc catalogue
 *
 * What may be added to this design point's hand calculation: each catalogue template with the scopes its applicability predicate admits on this graph and the facts that fit each of its symbols — the same offers the drafting request carries. `ready` says whether an offer can be added as it stands: every input symbol has a fact to bind and at least one of its scopes does not already carry it. `missing_symbols` names the inputs the run has no fact for. Editor role, same organization. No advisor call.
 */
export const handleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetOptions = (options: Options<HandleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetData>) => queryOptions<HandleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetResponse, HandleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetError, HandleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetResponse, ReturnType<typeof handleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleHandCalcCatalogueStudiesStudyIdPointsDpIdHandCalcCatalogueGetQueryKey(options)
});

/**
 * Preview study report
 *
 * Build a live report from the saved hand calculations of the named design points. Replays each record on its current attempt without an advisor call and persists nothing.
 */
export const handlePreviewStudyReportStudiesStudyIdReportPreviewPostMutation = (options?: Partial<Options<HandlePreviewStudyReportStudiesStudyIdReportPreviewPostData>>): UseMutationOptions<HandlePreviewStudyReportStudiesStudyIdReportPreviewPostResponse, HandlePreviewStudyReportStudiesStudyIdReportPreviewPostError, Options<HandlePreviewStudyReportStudiesStudyIdReportPreviewPostData>> => {
    const mutationOptions: UseMutationOptions<HandlePreviewStudyReportStudiesStudyIdReportPreviewPostResponse, HandlePreviewStudyReportStudiesStudyIdReportPreviewPostError, Options<HandlePreviewStudyReportStudiesStudyIdReportPreviewPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handlePreviewStudyReportStudiesStudyIdReportPreviewPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetStudyReportStudiesStudyIdReportGetQueryKey = (options: Options<HandleGetStudyReportStudiesStudyIdReportGetData>) => createQueryKey('handleGetStudyReportStudiesStudyIdReportGet', options);

/**
 * Get study report
 *
 * The study's report document — its prose, verdicts and tables. It carries no figures: those are drawn in the browser from the series this API serves separately. Both renderers read this: the web view and the browser-side PDF.
 */
export const handleGetStudyReportStudiesStudyIdReportGetOptions = (options: Options<HandleGetStudyReportStudiesStudyIdReportGetData>) => queryOptions<HandleGetStudyReportStudiesStudyIdReportGetResponse, HandleGetStudyReportStudiesStudyIdReportGetError, HandleGetStudyReportStudiesStudyIdReportGetResponse, ReturnType<typeof handleGetStudyReportStudiesStudyIdReportGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetStudyReportStudiesStudyIdReportGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetStudyReportStudiesStudyIdReportGetQueryKey(options)
});

/**
 * Write study report
 *
 * Write the study's report prose with the report writer and store it, overwriting whatever is there — the previous text is recoverable from the report's edit history. Requires editor: it spends a model call. Always 200; an unavailable writer is reported in the status, because an advisor being down does not make the study unreadable.
 */
export const handleWriteStudyReportStudiesStudyIdReportWritePostMutation = (options?: Partial<Options<HandleWriteStudyReportStudiesStudyIdReportWritePostData>>): UseMutationOptions<HandleWriteStudyReportStudiesStudyIdReportWritePostResponse, HandleWriteStudyReportStudiesStudyIdReportWritePostError, Options<HandleWriteStudyReportStudiesStudyIdReportWritePostData>> => {
    const mutationOptions: UseMutationOptions<HandleWriteStudyReportStudiesStudyIdReportWritePostResponse, HandleWriteStudyReportStudiesStudyIdReportWritePostError, Options<HandleWriteStudyReportStudiesStudyIdReportWritePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleWriteStudyReportStudiesStudyIdReportWritePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListCommentsStudiesStudyIdCommentsGetQueryKey = (options: Options<HandleListCommentsStudiesStudyIdCommentsGetData>) => createQueryKey('handleListCommentsStudiesStudyIdCommentsGet', options);

/**
 * List comments
 *
 * List the comments on a study, oldest first. Any viewer of the study can read them, including anonymous viewers of public studies.
 */
export const handleListCommentsStudiesStudyIdCommentsGetOptions = (options: Options<HandleListCommentsStudiesStudyIdCommentsGetData>) => queryOptions<HandleListCommentsStudiesStudyIdCommentsGetResponse, HandleListCommentsStudiesStudyIdCommentsGetError, HandleListCommentsStudiesStudyIdCommentsGetResponse, ReturnType<typeof handleListCommentsStudiesStudyIdCommentsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListCommentsStudiesStudyIdCommentsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListCommentsStudiesStudyIdCommentsGetQueryKey(options)
});

/**
 * Create comment
 *
 * Post a comment on a study; returns the created comment with its comment id. Requires commenter access or higher on the study.
 */
export const handleCreateCommentStudiesStudyIdCommentsPostMutation = (options?: Partial<Options<HandleCreateCommentStudiesStudyIdCommentsPostData>>): UseMutationOptions<HandleCreateCommentStudiesStudyIdCommentsPostResponse, HandleCreateCommentStudiesStudyIdCommentsPostError, Options<HandleCreateCommentStudiesStudyIdCommentsPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCreateCommentStudiesStudyIdCommentsPostResponse, HandleCreateCommentStudiesStudyIdCommentsPostError, Options<HandleCreateCommentStudiesStudyIdCommentsPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCreateCommentStudiesStudyIdCommentsPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete comment
 *
 * Soft-delete a comment; returns 204 with an empty body. Allowed for the comment's author or the owner of the study it belongs to.
 */
export const handleDeleteCommentCommentsCommentIdDeleteMutation = (options?: Partial<Options<HandleDeleteCommentCommentsCommentIdDeleteData>>): UseMutationOptions<HandleDeleteCommentCommentsCommentIdDeleteResponse, HandleDeleteCommentCommentsCommentIdDeleteError, Options<HandleDeleteCommentCommentsCommentIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleDeleteCommentCommentsCommentIdDeleteResponse, HandleDeleteCommentCommentsCommentIdDeleteError, Options<HandleDeleteCommentCommentsCommentIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleDeleteCommentCommentsCommentIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update comment
 *
 * Edit the body of one of your own comments; returns the updated comment. Only the author can edit; other users' comments return 404.
 */
export const handleUpdateCommentCommentsCommentIdPatchMutation = (options?: Partial<Options<HandleUpdateCommentCommentsCommentIdPatchData>>): UseMutationOptions<HandleUpdateCommentCommentsCommentIdPatchResponse, HandleUpdateCommentCommentsCommentIdPatchError, Options<HandleUpdateCommentCommentsCommentIdPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateCommentCommentsCommentIdPatchResponse, HandleUpdateCommentCommentsCommentIdPatchError, Options<HandleUpdateCommentCommentsCommentIdPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateCommentCommentsCommentIdPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change organization member status
 *
 * Suspend or reactivate an organization member in Stytch and PostgreSQL. Owner only; owner lifecycle changes remain transfer-first.
 */
export const handleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchMutation = (options?: Partial<Options<HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchData>>): UseMutationOptions<HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchResponse, HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchError, Options<HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchResponse, HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchError, Options<HandleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleChangeOrganizationMemberStatusOrganizationMembersMemberIdStatusPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change organization member role
 *
 * Change a member between admin and member using PostgreSQL authority. Owner only; owner transfer or demotion is rejected transfer-first.
 */
export const handleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchMutation = (options?: Partial<Options<HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchData>>): UseMutationOptions<HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchResponse, HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchError, Options<HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchData>> => {
    const mutationOptions: UseMutationOptions<HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchResponse, HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchError, Options<HandleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleChangeOrganizationMemberRoleOrganizationMembersMemberIdRolePatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign seat
 *
 * Release a member's paid seat in every product back to the organization's capacity. Owner only; never writes to Stripe. Legacy: prefer `DELETE .../seats/{product}`, which releases one product.
 */
export const handleUnassignSeatOrganizationMembersMemberIdSeatDeleteMutation = (options?: Partial<Options<HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteData>>): UseMutationOptions<HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteResponse, HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteError, Options<HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteResponse, HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteError, Options<HandleUnassignSeatOrganizationMembersMemberIdSeatDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUnassignSeatOrganizationMembersMemberIdSeatDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign seat
 *
 * Assign a paid seat to an active organization member in every product the organization holds that has a seat free. Owner only. Legacy: prefer `PUT .../seats/{product}`, which seats one product. 409 only when no product could seat the member; a product that is full is skipped, and the response's `seats` says which were taken.
 */
export const handleAssignSeatOrganizationMembersMemberIdSeatPutMutation = (options?: Partial<Options<HandleAssignSeatOrganizationMembersMemberIdSeatPutData>>): UseMutationOptions<HandleAssignSeatOrganizationMembersMemberIdSeatPutResponse, HandleAssignSeatOrganizationMembersMemberIdSeatPutError, Options<HandleAssignSeatOrganizationMembersMemberIdSeatPutData>> => {
    const mutationOptions: UseMutationOptions<HandleAssignSeatOrganizationMembersMemberIdSeatPutResponse, HandleAssignSeatOrganizationMembersMemberIdSeatPutError, Options<HandleAssignSeatOrganizationMembersMemberIdSeatPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleAssignSeatOrganizationMembersMemberIdSeatPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Unassign product seat
 *
 * Release a member's paid seat in one product back to the organization's capacity. Owner only; idempotent; never writes to Stripe. 422 for `khorium_agent` or an unknown product.
 */
export const handleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteMutation = (options?: Partial<Options<HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteData>>): UseMutationOptions<HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteResponse, HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteError, Options<HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteResponse, HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteError, Options<HandleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUnassignProductSeatOrganizationMembersMemberIdSeatsProductDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign product seat
 *
 * Assign an active organization member a paid seat in one product (`diagnosis`, `meshgen` or `simops`). Owner only; idempotent. 409 when the organization does not hold the product; 409 `seat_capacity_full` (the body names the product) when every purchased seat of it is assigned — buy more or unassign a member first; 422 for `khorium_agent`, which has no seats of its own, or an unknown product. Never writes to Stripe.
 */
export const handleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutMutation = (options?: Partial<Options<HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutData>>): UseMutationOptions<HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutResponse, HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutError, Options<HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutData>> => {
    const mutationOptions: UseMutationOptions<HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutResponse, HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutError, Options<HandleAssignProductSeatOrganizationMembersMemberIdSeatsProductPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleAssignProductSeatOrganizationMembersMemberIdSeatsProductPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove organization member
 *
 * Remove a non-owner member from Stytch and PostgreSQL. Owner only; owner removal is rejected transfer-first.
 */
export const handleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteMutation = (options?: Partial<Options<HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteData>>): UseMutationOptions<HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteResponse, HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteError, Options<HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteResponse, HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteError, Options<HandleRemoveOrganizationMemberOrganizationMembersMemberIdDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRemoveOrganizationMemberOrganizationMembersMemberIdDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetQueryKey = (options: Options<HandleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetData>) => createQueryKey('handleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGet', options);

/**
 * Get fluid material curve
 *
 * Sample a fluid's density, kinematic viscosity, specific heat and thermal conductivity over a temperature window. Returns tables keyed by the field names a fluid region config accepts, so the result can be assigned to a region unchanged. Query: `t_min_k`, `t_max_k`, `step_k`, all optional and all positive — OMIT one rather than sending it empty. 422 if a value is not a positive number, with the offending parameter in `detail[].loc`. 400 if the window is outside what the source covers or a table would miss the 1 % accuracy requirement — the message says which. 503 if this deployment cannot sample curves.
 */
export const handleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetOptions = (options: Options<HandleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetData>) => queryOptions<HandleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetResponse, HandleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetError, HandleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetResponse, ReturnType<typeof handleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetFluidMaterialCurveMaterialsFluidsFluidKeyCurveGetQueryKey(options)
});

export const handleHealthHealthGetQueryKey = (options?: Options<HandleHealthHealthGetData>) => createQueryKey('handleHealthHealthGet', options);

/**
 * Health check
 *
 * Check that the Khorium API is up. Returns status 'ok' plus the deployment environment name. Unauthenticated; used by load balancer health probes.
 */
export const handleHealthHealthGetOptions = (options?: Options<HandleHealthHealthGetData>) => queryOptions<HandleHealthHealthGetResponse, HandleHealthHealthGetError, HandleHealthHealthGetResponse, ReturnType<typeof handleHealthHealthGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleHealthHealthGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleHealthHealthGetQueryKey(options)
});

export const handleAuthConfigAuthConfigGetQueryKey = (options?: Options<HandleAuthConfigAuthConfigGetData>) => createQueryKey('handleAuthConfigAuthConfigGet', options);

/**
 * Get sign-in settings
 *
 * Return the Stytch B2B SDK configuration for this environment. Public; never includes a Stytch project secret.
 */
export const handleAuthConfigAuthConfigGetOptions = (options?: Options<HandleAuthConfigAuthConfigGetData>) => queryOptions<HandleAuthConfigAuthConfigGetResponse, HandleAuthConfigAuthConfigGetError, HandleAuthConfigAuthConfigGetResponse, ReturnType<typeof handleAuthConfigAuthConfigGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleAuthConfigAuthConfigGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleAuthConfigAuthConfigGetQueryKey(options)
});

export const handleAuthCurrentAuthCurrentGetQueryKey = (options?: Options<HandleAuthCurrentAuthCurrentGetData>) => createQueryKey('handleAuthCurrentAuthCurrentGet', options);

/**
 * Get current user
 *
 * Return canonical application identity and active organization derived from gateway-verified provider claims.
 */
export const handleAuthCurrentAuthCurrentGetOptions = (options?: Options<HandleAuthCurrentAuthCurrentGetData>) => queryOptions<HandleAuthCurrentAuthCurrentGetResponse, HandleAuthCurrentAuthCurrentGetError, HandleAuthCurrentAuthCurrentGetResponse, ReturnType<typeof handleAuthCurrentAuthCurrentGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleAuthCurrentAuthCurrentGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleAuthCurrentAuthCurrentGetQueryKey(options)
});

export const getChtColorsAuthPreferencesChtColormapGetQueryKey = (options?: Options<GetChtColorsAuthPreferencesChtColormapGetData>) => createQueryKey('getChtColorsAuthPreferencesChtColormapGet', options);

/**
 * Get CHT color map
 */
export const getChtColorsAuthPreferencesChtColormapGetOptions = (options?: Options<GetChtColorsAuthPreferencesChtColormapGetData>) => queryOptions<GetChtColorsAuthPreferencesChtColormapGetResponse, GetChtColorsAuthPreferencesChtColormapGetError, GetChtColorsAuthPreferencesChtColormapGetResponse, ReturnType<typeof getChtColorsAuthPreferencesChtColormapGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChtColorsAuthPreferencesChtColormapGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChtColorsAuthPreferencesChtColormapGetQueryKey(options)
});

/**
 * Save CHT color map
 */
export const putChtColorsAuthPreferencesChtColormapPutMutation = (options?: Partial<Options<PutChtColorsAuthPreferencesChtColormapPutData>>): UseMutationOptions<PutChtColorsAuthPreferencesChtColormapPutResponse, PutChtColorsAuthPreferencesChtColormapPutError, Options<PutChtColorsAuthPreferencesChtColormapPutData>> => {
    const mutationOptions: UseMutationOptions<PutChtColorsAuthPreferencesChtColormapPutResponse, PutChtColorsAuthPreferencesChtColormapPutError, Options<PutChtColorsAuthPreferencesChtColormapPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putChtColorsAuthPreferencesChtColormapPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get geometry upload URL
 *
 * Create a new geometry record and get a presigned S3 PUT URL for its CAD file; returns the new geometry_id and upload_url. PUT the file to the URL, then call confirm_geometry_upload to finalise the upload (or diagnose_geometry, which confirms when the object is present).
 */
export const handleUploadUrlGeometriesUploadUrlPostMutation = (options?: Partial<Options<HandleUploadUrlGeometriesUploadUrlPostData>>): UseMutationOptions<HandleUploadUrlGeometriesUploadUrlPostResponse, HandleUploadUrlGeometriesUploadUrlPostError, Options<HandleUploadUrlGeometriesUploadUrlPostData>> => {
    const mutationOptions: UseMutationOptions<HandleUploadUrlGeometriesUploadUrlPostResponse, HandleUploadUrlGeometriesUploadUrlPostError, Options<HandleUploadUrlGeometriesUploadUrlPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUploadUrlGeometriesUploadUrlPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListGeometriesGeometriesGetQueryKey = (options?: Options<HandleListGeometriesGeometriesGetData>) => createQueryKey('handleListGeometriesGeometriesGet', options);

/**
 * List geometries
 *
 * List the user's geometries, newest first, paginated. Each item carries its lineage's current-version diagnosis summary; call get_geometry for full detail.
 */
export const handleListGeometriesGeometriesGetOptions = (options?: Options<HandleListGeometriesGeometriesGetData>) => queryOptions<HandleListGeometriesGeometriesGetResponse, HandleListGeometriesGeometriesGetError, HandleListGeometriesGeometriesGetResponse, ReturnType<typeof handleListGeometriesGeometriesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListGeometriesGeometriesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListGeometriesGeometriesGetQueryKey(options)
});

export const handleListGeometriesGeometriesGetInfiniteQueryKey = (options?: Options<HandleListGeometriesGeometriesGetData>): QueryKey<Options<HandleListGeometriesGeometriesGetData>> => createQueryKey('handleListGeometriesGeometriesGet', options, true);

/**
 * List geometries
 *
 * List the user's geometries, newest first, paginated. Each item carries its lineage's current-version diagnosis summary; call get_geometry for full detail.
 */
export const handleListGeometriesGeometriesGetInfiniteOptions = (options?: Options<HandleListGeometriesGeometriesGetData>) => infiniteQueryOptions<HandleListGeometriesGeometriesGetResponse, HandleListGeometriesGeometriesGetError, InfiniteData<HandleListGeometriesGeometriesGetResponse>, QueryKey<Options<HandleListGeometriesGeometriesGetData>>, string | null | Pick<QueryKey<Options<HandleListGeometriesGeometriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<HandleListGeometriesGeometriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await handleListGeometriesGeometriesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListGeometriesGeometriesGetInfiniteQueryKey(options)
});

/**
 * Get face tags upload URL
 *
 * Get a presigned S3 PUT URL to upload a face_tags JSON array out-of-band, for high-face models whose inline face_tags would exceed the 1 MB request cap. PUT the array, then submit the mesh with mesh_params.face_tags_s3_key set to the returned s3_key (instead of the inline face_tags array).
 */
export const handleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostMutation = (options?: Partial<Options<HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostData>>): UseMutationOptions<HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostResponse, HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostError, Options<HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostData>> => {
    const mutationOptions: UseMutationOptions<HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostResponse, HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostError, Options<HandleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleFaceTagsUploadUrlMeshesFaceTagsUploadUrlPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get mesh upload URL
 *
 * Get a presigned S3 PUT URL to upload an existing mesh file directly. Creates a completed mesh row without running meshing and returns the new mesh_id with the upload_url; optionally attaches the mesh to a geometry.
 */
export const handleMeshUploadUrlMeshesUploadUrlPostMutation = (options?: Partial<Options<HandleMeshUploadUrlMeshesUploadUrlPostData>>): UseMutationOptions<HandleMeshUploadUrlMeshesUploadUrlPostResponse, HandleMeshUploadUrlMeshesUploadUrlPostError, Options<HandleMeshUploadUrlMeshesUploadUrlPostData>> => {
    const mutationOptions: UseMutationOptions<HandleMeshUploadUrlMeshesUploadUrlPostResponse, HandleMeshUploadUrlMeshesUploadUrlPostError, Options<HandleMeshUploadUrlMeshesUploadUrlPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleMeshUploadUrlMeshesUploadUrlPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListMeshesMeshesGetQueryKey = (options?: Options<HandleListMeshesMeshesGetData>) => createQueryKey('handleListMeshesMeshesGet', options);

/**
 * List meshes
 *
 * List all the user's meshes across geometries, newest first, paginated.
 */
export const handleListMeshesMeshesGetOptions = (options?: Options<HandleListMeshesMeshesGetData>) => queryOptions<HandleListMeshesMeshesGetResponse, HandleListMeshesMeshesGetError, HandleListMeshesMeshesGetResponse, ReturnType<typeof handleListMeshesMeshesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListMeshesMeshesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListMeshesMeshesGetQueryKey(options)
});

export const handleListMeshesMeshesGetInfiniteQueryKey = (options?: Options<HandleListMeshesMeshesGetData>): QueryKey<Options<HandleListMeshesMeshesGetData>> => createQueryKey('handleListMeshesMeshesGet', options, true);

/**
 * List meshes
 *
 * List all the user's meshes across geometries, newest first, paginated.
 */
export const handleListMeshesMeshesGetInfiniteOptions = (options?: Options<HandleListMeshesMeshesGetData>) => infiniteQueryOptions<HandleListMeshesMeshesGetResponse, HandleListMeshesMeshesGetError, InfiniteData<HandleListMeshesMeshesGetResponse>, QueryKey<Options<HandleListMeshesMeshesGetData>>, string | null | Pick<QueryKey<Options<HandleListMeshesMeshesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<HandleListMeshesMeshesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await handleListMeshesMeshesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListMeshesMeshesGetInfiniteQueryKey(options)
});

export const handleListSimulationsSimulationsGetQueryKey = (options?: Options<HandleListSimulationsSimulationsGetData>) => createQueryKey('handleListSimulationsSimulationsGet', options);

/**
 * List simulations
 *
 * List the user's simulations, newest first, paginated. Returns simulation ids with mesh_id, status, and sim_type; call get_simulation for full detail.
 */
export const handleListSimulationsSimulationsGetOptions = (options?: Options<HandleListSimulationsSimulationsGetData>) => queryOptions<HandleListSimulationsSimulationsGetResponse, HandleListSimulationsSimulationsGetError, HandleListSimulationsSimulationsGetResponse, ReturnType<typeof handleListSimulationsSimulationsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListSimulationsSimulationsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListSimulationsSimulationsGetQueryKey(options)
});

export const handleListSimulationsSimulationsGetInfiniteQueryKey = (options?: Options<HandleListSimulationsSimulationsGetData>): QueryKey<Options<HandleListSimulationsSimulationsGetData>> => createQueryKey('handleListSimulationsSimulationsGet', options, true);

/**
 * List simulations
 *
 * List the user's simulations, newest first, paginated. Returns simulation ids with mesh_id, status, and sim_type; call get_simulation for full detail.
 */
export const handleListSimulationsSimulationsGetInfiniteOptions = (options?: Options<HandleListSimulationsSimulationsGetData>) => infiniteQueryOptions<HandleListSimulationsSimulationsGetResponse, HandleListSimulationsSimulationsGetError, InfiniteData<HandleListSimulationsSimulationsGetResponse>, QueryKey<Options<HandleListSimulationsSimulationsGetData>>, string | null | Pick<QueryKey<Options<HandleListSimulationsSimulationsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<HandleListSimulationsSimulationsGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await handleListSimulationsSimulationsGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListSimulationsSimulationsGetInfiniteQueryKey(options)
});

export const handleGetSubscriptionSubscriptionGetQueryKey = (options?: Options<HandleGetSubscriptionSubscriptionGetData>) => createQueryKey('handleGetSubscriptionSubscriptionGet', options);

/**
 * Get subscription
 *
 * Get the caller's organization's subscription status, current period end, and `grants`: one entry per product the organization is entitled to, carrying the product and its allowance (`null` means unlimited). Grants describe entitlement, not consumption — they carry no usage figure. `pending_change` is a downward plan change waiting for the next renewal — the products the subscription moves to and when — or `null`. A caller with no organization, or an organization with no subscription, gets nulls and an empty list.
 */
export const handleGetSubscriptionSubscriptionGetOptions = (options?: Options<HandleGetSubscriptionSubscriptionGetData>) => queryOptions<HandleGetSubscriptionSubscriptionGetResponse, HandleGetSubscriptionSubscriptionGetError, HandleGetSubscriptionSubscriptionGetResponse, ReturnType<typeof handleGetSubscriptionSubscriptionGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetSubscriptionSubscriptionGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetSubscriptionSubscriptionGetQueryKey(options)
});

export const handleGetUsageUsageGetQueryKey = (options?: Options<HandleGetUsageUsageGetData>) => createQueryKey('handleGetUsageUsageGet', options);

/**
 * Get usage
 *
 * Get the caller's organization's **recorded usage** for the current subscription period: one entry per product the organization is granted, carrying its allowance, the usage measured against it, and the derived `remaining` and `excess`. Figures are organization-level totals pooled across every member, never per-member. `period` is `null` — and every entry `countable: false` with null figures — when the organization has no usable billing period; an entry is `countable: false` on its own when that product has no counter. `overage_permitted` is subscription **policy** state (may an overage be billed) and does not mean overage enforcement is implemented. Recorded usage, not invoice truth.
 */
export const handleGetUsageUsageGetOptions = (options?: Options<HandleGetUsageUsageGetData>) => queryOptions<HandleGetUsageUsageGetResponse, HandleGetUsageUsageGetError, HandleGetUsageUsageGetResponse, ReturnType<typeof handleGetUsageUsageGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetUsageUsageGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetUsageUsageGetQueryKey(options)
});

/**
 * Create checkout session
 *
 * Open a Stripe Checkout Session to buy the chosen `items` — each a product at a tier with its own seat count — and return the URL to send the buyer to. **Owner only.** `items` names a non-empty subset of `diagnosis`, `meshgen` and `simops`, once each — an organization buys only what it names, and three meshgen seats beside eight simops seats is an ordinary purchase. 403 when the caller does not own an organization, 409 when that organization already has an active subscription (change it at `/billing/subscription` instead) or when a product is listed twice, 400 for an unsellable product, an unknown tier, or a seat count over the ceiling; `seats` below 1 is a 422. Creates nothing locally: the subscription is recorded when Stripe reports the completed checkout, so the returned URL being opened, abandoned, or retried leaves no state behind.
 */
export const handleCreateCheckoutSessionBillingCheckoutPostMutation = (options?: Partial<Options<HandleCreateCheckoutSessionBillingCheckoutPostData>>): UseMutationOptions<HandleCreateCheckoutSessionBillingCheckoutPostResponse, HandleCreateCheckoutSessionBillingCheckoutPostError, Options<HandleCreateCheckoutSessionBillingCheckoutPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCreateCheckoutSessionBillingCheckoutPostResponse, HandleCreateCheckoutSessionBillingCheckoutPostError, Options<HandleCreateCheckoutSessionBillingCheckoutPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCreateCheckoutSessionBillingCheckoutPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change subscription
 *
 * Change what the caller's organization's **existing** subscription holds: move a product between Basic and Plus, add one it does not hold, drop one, or change a product's seat count. **Owner only.** `products` is the whole set the organization should hold afterwards, in the same shape `/billing/checkout` takes with `seats` optional per entry — a product omitted from it is removed, and an empty list is refused rather than read as a cancellation. A held product left without `seats` keeps the quantity the subscription already carries; a product being added must name its seats. **An upward change** — a product added, a tier moved to a higher price, or seats added — **is charged today**: the full month's difference times the seats, and the full month's hours arrive with it. **A downward change** — a product dropped, a tier moved to a lower price, or seats removed — **takes effect at the next renewal**, returned as `scheduled_for`; nothing is charged or credited and the organization keeps the hours it paid for until then. A request naming exactly the plans held today while a change is scheduled cancels that scheduled change. `/billing/subscription/preview` says what will be charged. 403 when the caller does not own an organization, 409 when that organization has no active subscription (buy one at `/billing/checkout` instead), when an upward change is asked for while a change is already scheduled (cancel it first), when a product is listed twice, or when a seat reduction would leave a product with more members seated than seats (unassign them first — the message names the product and the counts), 402 when the card on file is declined for the part charged today (nothing changes), 400 for an unsellable product, an unknown tier, an added product with no seat count, a seat count over the ceiling, or a request that changes nothing. Creates nothing locally: the organization's grants and the scheduled change are recorded when Stripe reports the updated subscription.
 */
export const handleChangeSubscriptionBillingSubscriptionPostMutation = (options?: Partial<Options<HandleChangeSubscriptionBillingSubscriptionPostData>>): UseMutationOptions<HandleChangeSubscriptionBillingSubscriptionPostResponse, HandleChangeSubscriptionBillingSubscriptionPostError, Options<HandleChangeSubscriptionBillingSubscriptionPostData>> => {
    const mutationOptions: UseMutationOptions<HandleChangeSubscriptionBillingSubscriptionPostResponse, HandleChangeSubscriptionBillingSubscriptionPostError, Options<HandleChangeSubscriptionBillingSubscriptionPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleChangeSubscriptionBillingSubscriptionPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview subscription change
 *
 * What the change `/billing/subscription` would make will cost today, and what waits for the renewal. **Owner only**, and **read-only** — nothing in Stripe or here is written. Takes the same body as that route and runs the same diff with the same Stripe parameters, so the figure shown before the change and the figure billed after it come from one calculation. Returns `amount_due` in **cents** with its currency — what the card is charged today for the upward part, `0` when nothing moves up — the current period's end, and `scheduled`: the products the subscription will hold from that date when the change has a downward part, `[]` when it has none. Refuses on exactly the same terms as the change itself — 403 for a non-owner, 409 with no active subscription or an upward change on top of a scheduled one, 400 for an unsellable product, an unknown tier, or a request that changes nothing.
 */
export const handlePreviewSubscriptionChangeBillingSubscriptionPreviewPostMutation = (options?: Partial<Options<HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostData>>): UseMutationOptions<HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostResponse, HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostError, Options<HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostData>> => {
    const mutationOptions: UseMutationOptions<HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostResponse, HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostError, Options<HandlePreviewSubscriptionChangeBillingSubscriptionPreviewPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handlePreviewSubscriptionChangeBillingSubscriptionPreviewPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create billing portal session
 *
 * Open a Stripe Customer Portal session for the caller's organization and return the URL to send them to. **Owner only**, the same gate `/billing/checkout` uses. The portal is for **invoices, payment method and cancellation only** — it deliberately cannot change the subscription, because its update UI would allow the seat quantity to fall below the seats already assigned. Plan and seat changes are self-serve at `/billing/subscription`, which refuses that. 403 when the caller does not own an organization, 409 when that organization has no billing account to manage (it has never subscribed), 503 when the portal is not configured. Creates nothing locally and returns a single-use, short-lived link: whatever the owner changes there arrives through the Stripe webhook like any other Stripe-side edit.
 */
export const handleCreateBillingPortalSessionBillingPortalPostMutation = (options?: Partial<Options<HandleCreateBillingPortalSessionBillingPortalPostData>>): UseMutationOptions<HandleCreateBillingPortalSessionBillingPortalPostResponse, HandleCreateBillingPortalSessionBillingPortalPostError, Options<HandleCreateBillingPortalSessionBillingPortalPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCreateBillingPortalSessionBillingPortalPostResponse, HandleCreateBillingPortalSessionBillingPortalPostError, Options<HandleCreateBillingPortalSessionBillingPortalPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCreateBillingPortalSessionBillingPortalPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stripe webhook
 *
 * Receive a Stripe webhook event. Verifies the stripe-signature header, then updates subscription records for checkout, invoice, and subscription lifecycle events; returns 400 on an invalid signature. Called by Stripe, not for interactive use.
 */
export const handleStripeWebhookRouteWebhooksStripePostMutation = (options?: Partial<Options<HandleStripeWebhookRouteWebhooksStripePostData>>): UseMutationOptions<HandleStripeWebhookRouteWebhooksStripePostResponse, HandleStripeWebhookRouteWebhooksStripePostError, Options<HandleStripeWebhookRouteWebhooksStripePostData>> => {
    const mutationOptions: UseMutationOptions<HandleStripeWebhookRouteWebhooksStripePostResponse, HandleStripeWebhookRouteWebhooksStripePostError, Options<HandleStripeWebhookRouteWebhooksStripePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleStripeWebhookRouteWebhooksStripePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListStudiesStudiesGetQueryKey = (options?: Options<HandleListStudiesStudiesGetData>) => createQueryKey('handleListStudiesStudiesGet', options);

/**
 * List studies
 *
 * List the user's studies, newest first, paginated. Each item carries the study id, name, status, visibility, and total/completed/failed point counts.
 */
export const handleListStudiesStudiesGetOptions = (options?: Options<HandleListStudiesStudiesGetData>) => queryOptions<HandleListStudiesStudiesGetResponse, HandleListStudiesStudiesGetError, HandleListStudiesStudiesGetResponse, ReturnType<typeof handleListStudiesStudiesGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListStudiesStudiesGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListStudiesStudiesGetQueryKey(options)
});

export const handleListStudiesStudiesGetInfiniteQueryKey = (options?: Options<HandleListStudiesStudiesGetData>): QueryKey<Options<HandleListStudiesStudiesGetData>> => createQueryKey('handleListStudiesStudiesGet', options, true);

/**
 * List studies
 *
 * List the user's studies, newest first, paginated. Each item carries the study id, name, status, visibility, and total/completed/failed point counts.
 */
export const handleListStudiesStudiesGetInfiniteOptions = (options?: Options<HandleListStudiesStudiesGetData>) => infiniteQueryOptions<HandleListStudiesStudiesGetResponse, HandleListStudiesStudiesGetError, InfiniteData<HandleListStudiesStudiesGetResponse>, QueryKey<Options<HandleListStudiesStudiesGetData>>, string | null | Pick<QueryKey<Options<HandleListStudiesStudiesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<HandleListStudiesStudiesGetData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                cursor: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await handleListStudiesStudiesGet({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListStudiesStudiesGetInfiniteQueryKey(options)
});

/**
 * Create study
 *
 * Create a new study in draft status with an optional name and config; returns the new study id. Edit the draft with update_study, then call run_study to start it.
 */
export const handleCreateStudyStudiesPostMutation = (options?: Partial<Options<HandleCreateStudyStudiesPostData>>): UseMutationOptions<HandleCreateStudyStudiesPostResponse, HandleCreateStudyStudiesPostError, Options<HandleCreateStudyStudiesPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCreateStudyStudiesPostResponse, HandleCreateStudyStudiesPostError, Options<HandleCreateStudyStudiesPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCreateStudyStudiesPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete organization
 *
 * Request irreversible organization teardown with explicit DELETE confirmation. Currently returns 409 before any side effect because billing teardown — cancelling the Stripe subscription and removing the billing rows — is not implemented yet. Owner only.
 */
export const handleTeardownOrganizationOrganizationDeleteMutation = (options?: Partial<Options<HandleTeardownOrganizationOrganizationDeleteData>>): UseMutationOptions<HandleTeardownOrganizationOrganizationDeleteResponse, HandleTeardownOrganizationOrganizationDeleteError, Options<HandleTeardownOrganizationOrganizationDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleTeardownOrganizationOrganizationDeleteResponse, HandleTeardownOrganizationOrganizationDeleteError, Options<HandleTeardownOrganizationOrganizationDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleTeardownOrganizationOrganizationDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleGetCurrentOrganizationOrganizationGetQueryKey = (options?: Options<HandleGetCurrentOrganizationOrganizationGetData>) => createQueryKey('handleGetCurrentOrganizationOrganizationGet', options);

/**
 * Get current organization
 *
 * Get the caller's current organization. Owner only; membership and role authority come from PostgreSQL.
 */
export const handleGetCurrentOrganizationOrganizationGetOptions = (options?: Options<HandleGetCurrentOrganizationOrganizationGetData>) => queryOptions<HandleGetCurrentOrganizationOrganizationGetResponse, HandleGetCurrentOrganizationOrganizationGetError, HandleGetCurrentOrganizationOrganizationGetResponse, ReturnType<typeof handleGetCurrentOrganizationOrganizationGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleGetCurrentOrganizationOrganizationGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleGetCurrentOrganizationOrganizationGetQueryKey(options)
});

/**
 * Rename organization
 *
 * Rename the current organization. Owner only; the name is written to Stytch and PostgreSQL together. Nothing else about the organization changes.
 */
export const handleRenameOrganizationOrganizationPatchMutation = (options?: Partial<Options<HandleRenameOrganizationOrganizationPatchData>>): UseMutationOptions<HandleRenameOrganizationOrganizationPatchResponse, HandleRenameOrganizationOrganizationPatchError, Options<HandleRenameOrganizationOrganizationPatchData>> => {
    const mutationOptions: UseMutationOptions<HandleRenameOrganizationOrganizationPatchResponse, HandleRenameOrganizationOrganizationPatchError, Options<HandleRenameOrganizationOrganizationPatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRenameOrganizationOrganizationPatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListOrganizationMembersOrganizationMembersGetQueryKey = (options?: Options<HandleListOrganizationMembersOrganizationMembersGetData>) => createQueryKey('handleListOrganizationMembersOrganizationMembersGet', options);

/**
 * List organization members
 *
 * List current organization members and pending invitations. Owner only; Stytch roles are not used for authorization.
 */
export const handleListOrganizationMembersOrganizationMembersGetOptions = (options?: Options<HandleListOrganizationMembersOrganizationMembersGetData>) => queryOptions<HandleListOrganizationMembersOrganizationMembersGetResponse, HandleListOrganizationMembersOrganizationMembersGetError, HandleListOrganizationMembersOrganizationMembersGetResponse, ReturnType<typeof handleListOrganizationMembersOrganizationMembersGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListOrganizationMembersOrganizationMembersGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListOrganizationMembersOrganizationMembersGetQueryKey(options)
});

/**
 * Invite organization member
 *
 * Invite one email as an admin or member. Creates an active Stytch B2B member, sends a magic link, and retains a PostgreSQL invited row until acceptance. Owner only.
 */
export const handleInviteOrganizationMemberOrganizationMembersInvitePostMutation = (options?: Partial<Options<HandleInviteOrganizationMemberOrganizationMembersInvitePostData>>): UseMutationOptions<HandleInviteOrganizationMemberOrganizationMembersInvitePostResponse, HandleInviteOrganizationMemberOrganizationMembersInvitePostError, Options<HandleInviteOrganizationMemberOrganizationMembersInvitePostData>> => {
    const mutationOptions: UseMutationOptions<HandleInviteOrganizationMemberOrganizationMembersInvitePostResponse, HandleInviteOrganizationMemberOrganizationMembersInvitePostError, Options<HandleInviteOrganizationMemberOrganizationMembersInvitePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleInviteOrganizationMemberOrganizationMembersInvitePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update organization domains
 *
 * Replace allowed domains used by Stytch restricted email JIT. Stytch rejects common consumer domains and requires both a verified email and an existing verified member with the same domain; this does not prove domain ownership. An empty list disables email JIT. Exact first authentication materializes an explicit PostgreSQL membership; the domain alone grants no application access. Owner only.
 */
export const handleUpdateOrganizationDomainsOrganizationDomainsPutMutation = (options?: Partial<Options<HandleUpdateOrganizationDomainsOrganizationDomainsPutData>>): UseMutationOptions<HandleUpdateOrganizationDomainsOrganizationDomainsPutResponse, HandleUpdateOrganizationDomainsOrganizationDomainsPutError, Options<HandleUpdateOrganizationDomainsOrganizationDomainsPutData>> => {
    const mutationOptions: UseMutationOptions<HandleUpdateOrganizationDomainsOrganizationDomainsPutResponse, HandleUpdateOrganizationDomainsOrganizationDomainsPutError, Options<HandleUpdateOrganizationDomainsOrganizationDomainsPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleUpdateOrganizationDomainsOrganizationDomainsPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Transfer organization ownership
 *
 * Atomically transfer organization ownership to one active member. Promotes the target, demotes the caller to admin, and updates the organization owner mirror under row locks. PostgreSQL roles are the only authority; Stytch roles are ignored.
 */
export const handleTransferOrganizationOwnershipOrganizationOwnershipTransferPostMutation = (options?: Partial<Options<HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostData>>): UseMutationOptions<HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostResponse, HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostError, Options<HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostData>> => {
    const mutationOptions: UseMutationOptions<HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostResponse, HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostError, Options<HandleTransferOrganizationOwnershipOrganizationOwnershipTransferPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleTransferOrganizationOwnershipOrganizationOwnershipTransferPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Check agent entitlement
 *
 * Decide whether one agent run may proceed against the organization's `khorium_agent` entitlement. Returns a verdict, not its inputs: the caller enforces and computes nothing. `deny` with a null allowance means the organization holds no live grant; `deny` with a finite one means it is past that allowance. The optional `call_site` names the surface about to run: a built-in site (retry, report, hand calculations) is checked for access to the product it serves and has no allowance, while `chat` and `title` are checked against the agent allowance. Authenticated by the `X-Internal-Token` shared secret, not by an end-user session. Called by KhoriumAgents, not for interactive use.
 */
export const handleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostMutation = (options?: Partial<Options<HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostData>>): UseMutationOptions<HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostResponse, HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostError, Options<HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostData>> => {
    const mutationOptions: UseMutationOptions<HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostResponse, HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostError, Options<HandleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleCheckAgentEntitlementInternalEntitlementsKhoriumAgentCheckPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Record agent usage
 *
 * Record one finished agent run's token spend as an `agent_usage_events` row. Idempotent on `(call_site, run_id)`: re-sending the same run is 204, not a conflict. 422 when the run window is inverted, 400 when the organization is unknown. Authenticated by the `X-Internal-Token` shared secret, not by an end-user session. Called by KhoriumAgents, not for interactive use.
 */
export const handleRecordAgentUsageInternalUsageAgentPostMutation = (options?: Partial<Options<HandleRecordAgentUsageInternalUsageAgentPostData>>): UseMutationOptions<HandleRecordAgentUsageInternalUsageAgentPostResponse, HandleRecordAgentUsageInternalUsageAgentPostError, Options<HandleRecordAgentUsageInternalUsageAgentPostData>> => {
    const mutationOptions: UseMutationOptions<HandleRecordAgentUsageInternalUsageAgentPostResponse, HandleRecordAgentUsageInternalUsageAgentPostError, Options<HandleRecordAgentUsageInternalUsageAgentPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleRecordAgentUsageInternalUsageAgentPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListFluidMaterialsMaterialsFluidsGetQueryKey = (options?: Options<HandleListFluidMaterialsMaterialsFluidsGetData>) => createQueryKey('handleListFluidMaterialsMaterialsFluidsGet', options);

/**
 * List fluid materials
 *
 * Every fluid in the library with its constant properties, the temperature they were taken at, their citation, and whether the fluid can be sampled as a temperature curve. Display names are not included — the frontend owns those.
 */
export const handleListFluidMaterialsMaterialsFluidsGetOptions = (options?: Options<HandleListFluidMaterialsMaterialsFluidsGetData>) => queryOptions<HandleListFluidMaterialsMaterialsFluidsGetResponse, HandleListFluidMaterialsMaterialsFluidsGetError, HandleListFluidMaterialsMaterialsFluidsGetResponse, ReturnType<typeof handleListFluidMaterialsMaterialsFluidsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListFluidMaterialsMaterialsFluidsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListFluidMaterialsMaterialsFluidsGetQueryKey(options)
});

export const handleListSolidMaterialsMaterialsSolidsGetQueryKey = (options?: Options<HandleListSolidMaterialsMaterialsSolidsGetData>) => createQueryKey('handleListSolidMaterialsMaterialsSolidsGet', options);

/**
 * List solid materials
 *
 * Every solid in the library with its constant properties, its citation, and its published conductivity-vs-temperature table where one exists. The table is returned inline rather than behind a second request: unlike a fluid curve it is fixed published data, with no window or step to ask for. `has_curves` false means the row is constants-only and `note` says why. Display names are not included — the frontend owns those.
 */
export const handleListSolidMaterialsMaterialsSolidsGetOptions = (options?: Options<HandleListSolidMaterialsMaterialsSolidsGetData>) => queryOptions<HandleListSolidMaterialsMaterialsSolidsGetResponse, HandleListSolidMaterialsMaterialsSolidsGetError, HandleListSolidMaterialsMaterialsSolidsGetResponse, ReturnType<typeof handleListSolidMaterialsMaterialsSolidsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListSolidMaterialsMaterialsSolidsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListSolidMaterialsMaterialsSolidsGetQueryKey(options)
});

export const handleListStructuralMaterialsMaterialsStructuralGetQueryKey = (options?: Options<HandleListStructuralMaterialsMaterialsStructuralGetData>) => createQueryKey('handleListStructuralMaterialsMaterialsStructuralGet', options);

/**
 * List structural materials
 *
 * Every structural material a CalculiX FEA run can be given: Young's modulus, Poisson's ratio, density, yield and ultimate strength, thermal expansion, and the heat-treatment condition those numbers are valid for. This is the library the FEA solver panel shows, so an agent grading a stress result or sizing a section reads the same numbers the engineer is looking at rather than a remembered handbook value. Keys match `StructuralStaticParams.material`, so a row can be selected into a study unchanged. A key here may also appear under `/materials/solids`, which carries that material's THERMAL properties for a CHT run — different data, same name. Display names are not included — the frontend owns those.
 */
export const handleListStructuralMaterialsMaterialsStructuralGetOptions = (options?: Options<HandleListStructuralMaterialsMaterialsStructuralGetData>) => queryOptions<HandleListStructuralMaterialsMaterialsStructuralGetResponse, HandleListStructuralMaterialsMaterialsStructuralGetError, HandleListStructuralMaterialsMaterialsStructuralGetResponse, ReturnType<typeof handleListStructuralMaterialsMaterialsStructuralGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListStructuralMaterialsMaterialsStructuralGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListStructuralMaterialsMaterialsStructuralGetQueryKey(options)
});

/**
 * Import property curve
 *
 * Read a two-column CSV as a property curve. Nothing is stored: the table comes back for the caller to put on a region property, and the run snapshots it into `sim_params` like every other table, so a corrected re-upload can never change a finished run.
 *
 * Checked the way a SOLID curve is, whatever the material: an uploaded table has no equation behind it to sample, so the accuracy estimate is the hide-one-point one, and it inherits that estimate's grid rules — at least five points, and no gap much wider than the one beside it. The estimate itself is returned on the table rather than enforced: a table is never refused for being too coarse.
 */
export const handleImportPropertyCurveMaterialsCurveImportPostMutation = (options?: Partial<Options<HandleImportPropertyCurveMaterialsCurveImportPostData>>): UseMutationOptions<HandleImportPropertyCurveMaterialsCurveImportPostResponse, HandleImportPropertyCurveMaterialsCurveImportPostError, Options<HandleImportPropertyCurveMaterialsCurveImportPostData>> => {
    const mutationOptions: UseMutationOptions<HandleImportPropertyCurveMaterialsCurveImportPostResponse, HandleImportPropertyCurveMaterialsCurveImportPostError, Options<HandleImportPropertyCurveMaterialsCurveImportPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleImportPropertyCurveMaterialsCurveImportPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleListSolverConstantsSolversCalculixConstantsGetQueryKey = (options?: Options<HandleListSolverConstantsSolversCalculixConstantsGetData>) => createQueryKey('handleListSolverConstantsSolversCalculixConstantsGet', options);

/**
 * List solver constants
 *
 * The fixed numbers a CalculiX run is produced and graded by, so a reader can see the assumptions behind a result instead of inferring them. Served from the same catalogue the solver imports, so these are the values the run actually used.
 *
 * Read `kind` before reasoning about a value — they are not interchangeable. `default` is a starting value a run may override, and `overridable_by` names the parameter that does it. `threshold` is where a verdict flips. `deck` describes the decks we write rather than the solver itself. `diagnosis` tunes how a failed run is explained and never changes a result. `format` is a fixed CalculiX file-layout fact nobody can act on. `runtime` is progress cadence.
 *
 * Read-only: changing a `default` is a per-run parameter, not a call to this route.
 */
export const handleListSolverConstantsSolversCalculixConstantsGetOptions = (options?: Options<HandleListSolverConstantsSolversCalculixConstantsGetData>) => queryOptions<HandleListSolverConstantsSolversCalculixConstantsGetResponse, HandleListSolverConstantsSolversCalculixConstantsGetError, HandleListSolverConstantsSolversCalculixConstantsGetResponse, ReturnType<typeof handleListSolverConstantsSolversCalculixConstantsGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleListSolverConstantsSolversCalculixConstantsGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleListSolverConstantsSolversCalculixConstantsGetQueryKey(options)
});

/**
 * End MCP session
 */
export const handleMcpDeleteMcpDeleteMutation = (options?: Partial<Options<HandleMcpDeleteMcpDeleteData>>): UseMutationOptions<HandleMcpDeleteMcpDeleteResponse, HandleMcpDeleteMcpDeleteError, Options<HandleMcpDeleteMcpDeleteData>> => {
    const mutationOptions: UseMutationOptions<HandleMcpDeleteMcpDeleteResponse, HandleMcpDeleteMcpDeleteError, Options<HandleMcpDeleteMcpDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleMcpDeleteMcpDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleMcpGetMcpGetQueryKey = (options?: Options<HandleMcpGetMcpGetData>) => createQueryKey('handleMcpGetMcpGet', options);

/**
 * Open MCP stream
 */
export const handleMcpGetMcpGetOptions = (options?: Options<HandleMcpGetMcpGetData>) => queryOptions<HandleMcpGetMcpGetResponse, HandleMcpGetMcpGetError, HandleMcpGetMcpGetResponse, ReturnType<typeof handleMcpGetMcpGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleMcpGetMcpGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleMcpGetMcpGetQueryKey(options)
});

/**
 * MCP request
 */
export const handleMcpPostMcpPostMutation = (options?: Partial<Options<HandleMcpPostMcpPostData>>): UseMutationOptions<HandleMcpPostMcpPostResponse, HandleMcpPostMcpPostError, Options<HandleMcpPostMcpPostData>> => {
    const mutationOptions: UseMutationOptions<HandleMcpPostMcpPostResponse, HandleMcpPostMcpPostError, Options<HandleMcpPostMcpPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await handleMcpPostMcpPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const handleProtectedResourceMetadataWellKnownOauthProtectedResourceGetQueryKey = (options?: Options<HandleProtectedResourceMetadataWellKnownOauthProtectedResourceGetData>) => createQueryKey('handleProtectedResourceMetadataWellKnownOauthProtectedResourceGet', options);

/**
 * OAuth protected resource metadata
 */
export const handleProtectedResourceMetadataWellKnownOauthProtectedResourceGetOptions = (options?: Options<HandleProtectedResourceMetadataWellKnownOauthProtectedResourceGetData>) => queryOptions<HandleProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponse, HandleProtectedResourceMetadataWellKnownOauthProtectedResourceGetError, HandleProtectedResourceMetadataWellKnownOauthProtectedResourceGetResponse, ReturnType<typeof handleProtectedResourceMetadataWellKnownOauthProtectedResourceGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleProtectedResourceMetadataWellKnownOauthProtectedResourceGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleProtectedResourceMetadataWellKnownOauthProtectedResourceGetQueryKey(options)
});

export const handleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetQueryKey = (options?: Options<HandleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetData>) => createQueryKey('handleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGet', options);

/**
 * OAuth authorization server metadata
 */
export const handleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetOptions = (options?: Options<HandleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetData>) => queryOptions<HandleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetResponse, HandleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetError, HandleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetResponse, ReturnType<typeof handleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleAuthorizationServerMetadataWellKnownOauthAuthorizationServerGetQueryKey(options)
});

export const handleAuthorizationEndpointOauthAuthorizeGetQueryKey = (options?: Options<HandleAuthorizationEndpointOauthAuthorizeGetData>) => createQueryKey('handleAuthorizationEndpointOauthAuthorizeGet', options);

/**
 * Authorize MCP client
 */
export const handleAuthorizationEndpointOauthAuthorizeGetOptions = (options?: Options<HandleAuthorizationEndpointOauthAuthorizeGetData>) => queryOptions<HandleAuthorizationEndpointOauthAuthorizeGetResponse, HandleAuthorizationEndpointOauthAuthorizeGetError, HandleAuthorizationEndpointOauthAuthorizeGetResponse, ReturnType<typeof handleAuthorizationEndpointOauthAuthorizeGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await handleAuthorizationEndpointOauthAuthorizeGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: handleAuthorizationEndpointOauthAuthorizeGetQueryKey(options)
});
